<template>
  <div
    class="shopee-container"
    @click="selectLocation($event)"
    id="shopeeContainer"
    @mouseover="overSelection($event)"
    @mouseout="outSelection($event)"
  >
    <div class="shopee-container-mark-layer"></div>
    <div class="header-container exclude">
      <div class="navbar">
        <div class="navbar-left">
          <div class="split-line">
            卖家中心
          </div>
          <div class="split-line">
            下载
          </div>
          <div class="no-split">
            关注我们
          </div>
          <div class="no-split icon-wrap">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-tian7_facebook"></use>
            </svg>
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-instagam"></use>
            </svg>
          </div>
        </div>
        <div class="navbar-space"></div>
        <div class="navbar-right">
          <div class="split-line icon-wrap">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-tongzhi"></use>
            </svg>
            通知
          </div>
          <div class="no-split icon-wrap">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-wenhao"></use>
            </svg>
            帮助中心
          </div>
          <div class="no-split">
            <div>
              注册
            </div>
            <div class="split"></div>
            <div>
              登录
            </div>
          </div>
        </div>
      </div>
      <div class="container-wrapper">
        <div class="logo">
          <svg
            viewBox="0 0 192 65"
            class="shopee-svg-icon header-with-search__shopee-logo icon-shopee-logo"
          >
            <g fill-rule="evenodd">
              <path
                d="M35.6717403 44.953764c-.3333497 2.7510509-2.0003116 4.9543414-4.5823845 6.0575984-1.4379707.6145919-3.36871.9463856-4.896954.8421628-2.3840266-.0911143-4.6237865-.6708937-6.6883352-1.7307424-.7375522-.3788551-1.8370513-1.1352759-2.6813095-1.8437757-.213839-.1790053-.239235-.2937577-.0977428-.4944671.0764015-.1151823.2172535-.3229831.5286218-.7791994.45158-.6616533.5079208-.7446018.5587128-.8221779.14448-.2217688.3792333-.2411091.6107855-.0588804.0243289.0189105.0243289.0189105.0426824.0333083.0379873.0294402.0379873.0294402.1276204.0990653.0907002.0706996.14448.1123887.166248.1287205 2.2265285 1.7438508 4.8196989 2.7495466 7.4376251 2.8501162 3.6423042-.0496401 6.2615109-1.6873341 6.7308041-4.2020035.5160305-2.7675977-1.6565047-5.1582742-5.9070334-6.4908212-1.329344-.4166762-4.6895175-1.7616869-5.3090528-2.1250697-2.9094471-1.7071043-4.2697358-3.9430584-4.0763845-6.7048539.296216-3.8283059 3.8501677-6.6835796 8.340785-6.702705 2.0082079-.004083 4.0121475.4132378 5.937338 1.2244562.6816382.2873109 1.8987274.9496089 2.3189359 1.2633517.2420093.1777159.2898136.384872.1510957.60836-.0774686.12958-.2055158.3350171-.4754821.7632974l-.0029878.0047276c-.3553311.5640922-.3664286.5817134-.447952.7136572-.140852.2144625-.3064598.2344475-.5604202.0732783-2.0600669-1.3839063-4.3437898-2.0801572-6.8554368-2.130442-3.126914.061889-5.4706057 1.9228561-5.6246892 4.4579402-.0409751 2.2896772 1.676352 3.9613243 5.3858811 5.2358503 7.529819 2.4196871 10.4113092 5.25648 9.869029 9.7292478M26.3725216 5.42669372c4.9022893 0 8.8982174 4.65220288 9.0851664 10.47578358H17.2875686c.186949-5.8235807 4.1828771-10.47578358 9.084953-10.47578358m25.370857 11.57065968c0-.6047069-.4870064-1.0948761-1.0875481-1.0948761h-11.77736c-.28896-7.68927544-5.7774923-13.82058185-12.5059489-13.82058185-6.7282432 0-12.2167755 6.13130641-12.5057355 13.82058185l-11.79421958.0002149c-.59136492.0107446-1.06748731.4968309-1.06748731 1.0946612 0 .0285807.00106706.0569465.00320118.0848825H.99995732l1.6812605 37.0613963c.00021341.1031483.00405483.2071562.01173767.3118087.00170729.0236381.003628.0470614.00554871.0704847l.00362801.0782207.00405483.004083c.25545428 2.5789222 2.12707837 4.6560709 4.67201764 4.7519129l.00576212.0055872h37.4122078c.0177132.0002149.0354264.0004298.0531396.0004298.0177132 0 .0354264-.0002149.0531396-.0004298h.0796027l.0017073-.0015043c2.589329-.0706995 4.6867431-2.1768587 4.9082648-4.787585l.0012805-.0012893.0017073-.0350275c.0021341-.0275062.0040548-.0547975.0057621-.0823037.0040548-.065757.0068292-.1312992.0078963-.1964115l1.8344904-37.207738h-.0012805c.001067-.0186956.0014939-.0376062.0014939-.0565167M176.465457 41.1518926c.720839-2.3512494 2.900423-3.9186779 5.443734-3.9186779 2.427686 0 4.739107 1.6486899 5.537598 3.9141989l.054826.1556978h-11.082664l.046506-.1512188zm13.50267 3.4063683c.014933.0006399.014933.0006399.036906.0008531.021973-.0002132.021973-.0002132.044372-.0008531.53055-.0243144.950595-.4766911.950595-1.0271786 0-.0266606-.000853-.0496953-.00256-.0865936.000427-.0068251.000427-.020262.000427-.0635588 0-5.1926268-4.070748-9.4007319-9.09145-9.4007319-5.020488 0-9.091235 4.2081051-9.091235 9.4007319 0 .3871116.022399.7731567.067838 1.1568557l.00256.0204753.01408.1013102c.250022 1.8683731 1.047233 3.5831812 2.306302 4.9708108-.00064-.0006399.00064.0006399.007253.0078915 1.396026 1.536289 3.291455 2.5833031 5.393601 2.9748936l.02752.0053321v-.0027727l.13653.0228215c.070186.0119439.144211.0236746.243409.039031 2.766879.332724 5.221231-.0661182 7.299484-1.1127057.511777-.2578611.971928-.5423827 1.37064-.8429007.128211-.0968312.243622-.1904632.34346-.2781231.051412-.0452164.092372-.083181.114131-.1051493.468898-.4830897.498124-.6543572.215249-1.0954297-.31146-.4956734-.586228-.9179769-.821744-1.2675504-.082345-.1224254-.154023-.2267215-.214396-.3133151-.033279-.0475624-.033279-.0475624-.054399-.0776356-.008319-.0117306-.008319-.0117306-.013866-.0191956l-.00256-.0038391c-.256208-.3188605-.431565-.3480805-.715933-.0970445-.030292.0268739-.131624.1051493-.14997.1245582-1.999321 1.775381-4.729508 2.3465571-7.455854 1.7760208-.507724-.1362888-.982595-.3094759-1.419919-.5184948-1.708127-.8565509-2.918343-2.3826022-3.267563-4.1490253l-.02752-.1394881h13.754612zM154.831964 41.1518926c.720831-2.3512494 2.900389-3.9186779 5.44367-3.9186779 2.427657 0 4.739052 1.6486899 5.537747 3.9141989l.054612.1556978h-11.082534l.046505-.1512188zm13.502512 3.4063683c.015146.0006399.015146.0006399.037118.0008531.02176-.0002132.02176-.0002132.044159-.0008531.530543-.0243144.950584-.4766911.950584-1.0271786 0-.0266606-.000854-.0496953-.00256-.0865936.000426-.0068251.000426-.020262.000426-.0635588 0-5.1926268-4.070699-9.4007319-9.091342-9.4007319-5.020217 0-9.091343 4.2081051-9.091343 9.4007319 0 .3871116.022826.7731567.068051 1.1568557l.00256.0204753.01408.1013102c.250019 1.8683731 1.04722 3.5831812 2.306274 4.9708108-.00064-.0006399.00064.0006399.007254.0078915 1.396009 1.536289 3.291417 2.5833031 5.393538 2.9748936l.027519.0053321v-.0027727l.136529.0228215c.070184.0119439.144209.0236746.243619.039031 2.766847.332724 5.22117-.0661182 7.299185-1.1127057.511771-.2578611.971917-.5423827 1.370624-.8429007.128209-.0968312.243619-.1904632.343456-.2781231.051412-.0452164.09237-.083181.11413-.1051493.468892-.4830897.498118-.6543572.215246-1.0954297-.311457-.4956734-.586221-.9179769-.821734-1.2675504-.082344-.1224254-.154022-.2267215-.21418-.3133151-.033492-.0475624-.033492-.0475624-.054612-.0776356-.008319-.0117306-.008319-.0117306-.013866-.0191956l-.002346-.0038391c-.256419-.3188605-.431774-.3480805-.716138-.0970445-.030292.0268739-.131623.1051493-.149969.1245582-1.999084 1.775381-4.729452 2.3465571-7.455767 1.7760208-.507717-.1362888-.982582-.3094759-1.419902-.5184948-1.708107-.8565509-2.918095-2.3826022-3.267311-4.1490253l-.027733-.1394881h13.754451zM138.32144123 49.7357905c-3.38129629 0-6.14681004-2.6808521-6.23169343-6.04042014v-.31621743c.08401943-3.35418649 2.85039714-6.03546919 6.23169343-6.03546919 3.44242097 0 6.23320537 2.7740599 6.23320537 6.1960534 0 3.42199346-2.7907844 6.19605336-6.23320537 6.19605336m.00172791-15.67913203c-2.21776751 0-4.33682838.7553485-6.03989586 2.140764l-.19352548.1573553V34.6208558c0-.4623792-.0993546-.56419733-.56740117-.56419733h-2.17651376c-.47409424 0-.56761716.09428403-.56761716.56419733v27.6400724c0 .4539841.10583425.5641973.56761716.5641973h2.17651376c.46351081 0 .56740117-.1078454.56740117-.5641973V50.734168l.19352548.1573553c1.70328347 1.3856307 3.82234434 2.1409792 6.03989586 2.1409792 5.27140956 0 9.54473746-4.2479474 9.54473746-9.48802964 0-5.239867-4.2733279-9.48781439-9.54473746-9.48781439M115.907646 49.5240292c-3.449458 0-6.245805-2.7496948-6.245805-6.1425854 0-3.3928907 2.79656-6.1427988 6.245805-6.1427988 3.448821 0 6.24538 2.7499081 6.24538 6.1427988 0 3.3926772-2.796346 6.1425854-6.24538 6.1425854m.001914-15.5438312c-5.28187 0-9.563025 4.2112903-9.563025 9.4059406 0 5.1944369 4.281155 9.4059406 9.563025 9.4059406 5.281657 0 9.562387-4.2115037 9.562387-9.4059406 0-5.1946503-4.280517-9.4059406-9.562387-9.4059406M94.5919049 34.1890939c-1.9281307 0-3.7938902.6198995-5.3417715 1.7656047l-.188189.1393105V23.2574169c0-.4254677-.1395825-.5643476-.5649971-.5643476h-2.2782698c-.4600414 0-.5652122.1100273-.5652122.5643476v29.2834155c0 .443339.1135587.5647782.5652122.5647782h2.2782698c.4226187 0 .5649971-.1457701.5649971-.5647782v-9.5648406c.023658-3.011002 2.4931278-5.4412923 5.5299605-5.4412923 3.0445753 0 5.516841 2.4421328 5.5297454 5.4630394v9.5430935c0 .4844647.0806524.5645628.5652122.5645628h2.2726775c.481764 0 .565212-.0824666.565212-.5645628v-9.5710848c-.018066-4.8280677-4.0440197-8.7806537-8.9328471-8.7806537M62.8459442 47.7938061l-.0053397.0081519c-.3248668.4921188-.4609221.6991347-.5369593.8179812-.2560916.3812097-.224267.551113.1668119.8816949.91266.7358184 2.0858968 1.508535 2.8774525 1.8955369 2.2023021 1.076912 4.5810275 1.646045 7.1017886 1.6975309 1.6283921.0821628 3.6734936-.3050536 5.1963734-.9842376 2.7569891-1.2298679 4.5131066-3.6269626 4.8208863-6.5794607.4985136-4.7841067-2.6143125-7.7747902-10.6321784-10.1849709l-.0021359-.0006435c-3.7356476-1.2047686-5.4904836-2.8064071-5.4911243-5.0426086.1099976-2.4715346 2.4015793-4.3179454 5.4932602-4.4331449 2.4904317.0062212 4.6923065.6675996 6.8557356 2.0598624.4562232.2767364.666607.2256796.9733188-.172263.035242-.0587797.1332787-.2012238.543367-.790093l.0012815-.0019308c.3829626-.5500403.5089793-.7336731.5403767-.7879478.258441-.4863266.2214903-.6738208-.244985-1.0046173-.459427-.3290803-1.7535544-1.0024722-2.4936356-1.2978721-2.0583439-.8211991-4.1863175-1.2199998-6.3042524-1.1788111-4.8198184.1046878-8.578747 3.2393171-8.8265087 7.3515337-.1572005 2.9703036 1.350301 5.3588174 4.5000778 7.124567.8829712.4661613 4.1115618 1.6865902 5.6184225 2.1278667 4.2847814 1.2547527 6.5186944 3.5630343 6.0571315 6.2864205-.4192725 2.4743234-3.0117991 4.1199394-6.6498372 4.2325647-2.6382344-.0549182-5.2963324-1.0217793-7.6043603-2.7562084-.0115337-.0083664-.0700567-.0519149-.1779185-.1323615-.1516472-.1130543-.1516472-.1130543-.1742875-.1300017-.4705335-.3247898-.7473431-.2977598-1.0346184.1302162-.0346012.0529875-.3919333.5963776-.5681431.8632459"
              ></path>
            </g>
          </svg>
        </div>
        <div class="search-wrap" id="searchWrap">
          <div class="search-box">
            <div class="input-view">
              <input type="text" v-model="search" />
              <div class="icon" id="searchBtn" @click="handleSearch">
                <svg
                  t="1623034943568"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="9113"
                  width="14"
                  height="14"
                >
                  <path
                    d="M435.2 51.2c212.0704 0 384 171.9296 384 384 0 87.6544-29.3632 168.448-78.7968 233.0624l208.8704 213.6832a12.8 12.8 0 0 1-0.2048 18.1248l-54.9376 53.6832a12.8 12.8 0 0 1-18.0992-0.2048l-208.128-212.8896A382.3104 382.3104 0 0 1 435.2 819.2C223.1296 819.2 51.2 647.2704 51.2 435.2 51.2 223.1296 223.1296 51.2 435.2 51.2z m0 102.4C279.68 153.6 153.6 279.68 153.6 435.2s126.08 281.6 281.6 281.6 281.6-126.08 281.6-281.6S590.72 153.6 435.2 153.6z"
                    p-id="9114"
                  ></path>
                </svg>
              </div>
            </div>
            <div class="search-info" id="searchInfo">
              <span @click="clickSearchInfo('Lapsang souchong')">
                Lapsang souchong
              </span>
              <span @click="clickSearchInfo('Dahongpao Tea')">
                Dahongpao Tea
              </span>
              <span @click="clickSearchInfo('jasmine tea')">
                Jasmine tea
              </span>
              <span @click="clickSearchInfo('Green Tea')">
                Green Tea
              </span>
            </div>
          </div>
        </div>
        <div class="shopcar">
          <svg
            t="1623034757222"
            class="icon"
            viewBox="0 0 1028 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="8282"
            width="200"
            height="200"
          >
            <path
              d="M340.26666667 778.92266667q18.64533333 0 35.328 6.86933333t28.94933333 19.136 19.62666667 28.94933333 7.36 35.328-7.36 35.328-19.62666667 28.94933334-28.94933333 19.62666666-35.328 7.36q-19.62666667 0-36.30933334-7.36t-28.94933333-19.62666666-19.62666667-28.94933334-7.36-35.328 7.36-35.328 19.62666667-28.94933333 28.94933333-19.136 36.30933334-6.86933333zM748.50133333 780.88533333q18.64533333 0 35.81866667 6.86933334t29.44 19.136 19.62666667 28.94933333 7.36 35.328-7.36 35.328-19.62666667 28.94933333-29.44 19.62666667-35.81866667 7.36-35.328-7.36-28.94933333-19.62666667-19.62666667-28.94933333-7.36-35.328 7.36-35.328 19.62666667-28.94933333 28.94933333-19.136 35.328-6.86933334zM913.36533333 223.488q27.47733333 0 42.688 7.36t21.58933334 18.15466667 5.888 23.06133333-3.43466667 21.09866667-12.75733333 36.30933333-21.09866667 60.352-22.57066667 65.25866667-18.15466666 51.02933333q-12.75733333 39.25333333-31.89333334 54.464t-47.59466666 15.21066667l-34.34666667 0-62.80533333 0-82.432 0-92.24533334 0-243.37066666 0 13.73866666 88.32 495.57333334 0q47.104 0 47.104 40.23466666 0 19.62666667-9.32266667 34.34666667t-36.8 13.73866667l-47.104 0-90.28266667 0-113.83466666 0-114.816 0-95.18933334 0-52.992 0q-19.62666667 0-32.87466666-8.832t-22.08-23.06133334-14.22933334-30.912-8.34133333-31.40266666q-0.98133333-5.888-5.39733333-28.45866667t-10.79466667-56.42666667-14.22933333-75.56266666-15.70133334-83.904q-18.64533333-99.11466667-42.19733333-220.8l-73.6 0q-14.72 0-24.53333333-7.36t-16.192-17.664-8.832-22.08-2.45333334-21.58933334q0-19.62666667 13.248-32.384t35.81866667-11.776l99.11466667 0q19.62666667 0 31.40266666 5.888t18.64533334 14.72 9.81333333 18.15466667 4.90666667 16.192q1.96266667 7.85066667 3.92533333 22.08t3.92533333 28.94933333q2.944 17.664 5.888 37.29066667l671.232 0zM877.056 310.82666667l-614.31466667-1.96266667 34.34666667 177.62133333 513.23733333 0.98133334z"
              p-id="8283"
            ></path>
          </svg>
        </div>
      </div>
    </div>
    <div v-show="!hid" class="main-container">
      <div class="main-container-view">
        <div class="product-content">
          <div class="section-title exclude" style="margin-bottom: 0">
            <div class="section-title-txt">
              <div class="keyword exclude">
                "<span>{{ products.axiosParams.keyword }}</span
                >"
              </div>
              <div class="txt exclude">
                相关的卖场
              </div>
            </div>
            <div class="more-link exclude noerror">
              <div
                :class="
                  activeItem === '#location-item-3' &&
                  items[activeItem].actived &&
                  items[activeItem].isActive
                    ? 'mark animate__animated animate__flash animate__repeat-2'
                    : ''
                "
                class="more-link-view exclude noerror"
                id="moreLink"
                @click="showMore"
              >
                <span class="exclude noerror">查看更多</span>
                <i class="el-icon-arrow-right exclude noerror"></i>
              </div>
            </div>
          </div>
          <div class="seller-item" id="sellerItem">
            <div class="shop-img">
              <img :src="sellers.items[0].logo" alt="" />
            </div>
            <div class="shop-info exclude">
              <div class="info-item-nickname">
                {{ sellers.items[0].nickName }}
              </div>
              <div class="info-item-username">
                {{ sellers.items[0].userName }}
              </div>
              <div class="info-item-follow">
                {{ sellers.items[0].follow }}
              </div>
            </div>
            <div class="shop-statistics exclude">
              <div class="shop-statistics-item">
                <div class="shop-statistics-item-wrapper exclude">
                  <div class="item-header exclude">
                    <svg
                      style="width: 14px;height: 14px"
                      enable-background="new 0 0 15 15"
                      viewBox="0 0 15 15"
                      x="0"
                      y="0"
                      class="shopee-svg-icon icon-products exclude"
                    >
                      <g class="exclude">
                        <path
                          class="exclude"
                          d="m10 1 4.5 2.5-.5 3h-2v7.5h-9v-7.5h-2l-.5-3 4.6-2.5c.3 1.1 1.3 1.9 2.4 1.9s2.1-.8 2.5-1.9z"
                          fill="none"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-miterlimit="10"
                        ></path>
                        <line
                          class="exclude"
                          fill="none"
                          stroke-linecap="round"
                          stroke-miterlimit="10"
                          x1="3"
                          x2="12"
                          y1="11.5"
                          y2="11.5"
                        ></line>
                      </g>
                    </svg>
                    <span class="exclude">
                      {{ sellers.items[0].products }}
                    </span>
                  </div>
                  <div class="item-text exclude">
                    商品
                  </div>
                </div>
              </div>
              <div
                :class="
                  activeItem === '#location-item-2' &&
                  items[activeItem].actived &&
                  items[activeItem].isActive
                    ? 'mark animate__animated animate__flash animate__repeat-2'
                    : ''
                "
                class="shop-statistics-item "
                id="shop-statistics-item-sales"
              >
                <div class="shop-statistics-item-wrapper exclude">
                  <div class="item-header exclude">
                    <svg
                      t="1625644219567"
                      class="icon exclude"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="955"
                      width="200"
                      height="200"
                    >
                      <path
                        d="M512.33140179 15.61534137a265.12143803 265.12143803 0 0 1 265.12143803 265.12143802h132.56071902a44.18690591 44.18690591 0 0 1 44.1869059 44.18690591l-44.1869059 618.61668915a44.18690591 44.18690591 0 0 1-44.18690592 44.1869059h-706.99050225a44.18690591 44.18690591 0 0 1-44.1869059-44.1869059l-44.18690591-618.61668915a44.18690591 44.18690591 0 0 1 44.18690591-44.18690591h132.560719a265.12143803 265.12143803 0 0 1 265.12143802-265.12143802z m176.74762493 265.12143802a176.74762492 176.74762492 0 1 0-353.49524983 0h353.49524983z m-530.24287605 88.37381181l44.1869072 530.24287605h618.61668786l44.18690719-530.24287605h-706.99050225z m220.93453211 309.30834523v88.3738118a44.18690591 44.18690591 0 0 1-88.37381311 0v-88.3738118a44.18690591 44.18690591 0 0 1 88.37381311 0z m176.74762492-44.18690721v132.56071901a44.18690591 44.18690591 0 0 1-88.37381181 0v-132.56071901a44.18690591 44.18690591 0 0 1 88.37381181 0z m176.74762622-88.3738118v220.93453081a44.18690591 44.18690591 0 0 1-88.37381312 0v-220.93453081a44.18690591 44.18690591 0 0 1 88.37381312 0z"
                        p-id="956"
                      ></path>
                    </svg>
                    <span class="exclude">
                      {{ sellers.items[0].summary }}
                    </span>
                  </div>
                  <div class="item-text exclude">
                    销量
                  </div>
                </div>
              </div>
              <div
                :class="
                  activeItem === '#location-item-4' &&
                  items[activeItem].actived &&
                  items[activeItem].isActive
                    ? 'mark animate__animated animate__flash animate__repeat-2'
                    : ''
                "
                class="shop-statistics-item "
                id="shop-statistics-item-evaluate"
              >
                <div class="shop-statistics-item-wrapper exclude">
                  <div class="item-header exclude">
                    <svg
                      enable-background="new 0 0 15 15"
                      viewBox="0 0 15 15"
                      x="0"
                      y="0"
                      class="shopee-svg-icon icon-rating exclude"
                    >
                      <polygon
                        fill="none"
                        points="7.5 .8 9.7 5.4 14.5 5.9 10.7 9.1 11.8 14.2 7.5 11.6 3.2 14.2 4.3 9.1 .5 5.9 5.3 5.4"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-miterlimit="10"
                      ></polygon>
                    </svg>
                    <span class="exclude">
                      {{ sellers.items[0].comment }}
                    </span>
                  </div>
                  <div class="item-text exclude">
                    商品评价
                  </div>
                </div>
              </div>
              <div class="shop-statistics-item">
                <div class="shop-statistics-item-wrapper exclude">
                  <div class="item-header exclude">
                    <svg
                      enable-background="new 0 0 15 15"
                      viewBox="0 0 15 15"
                      x="0"
                      y="0"
                      class="shopee-svg-icon exclude"
                    >
                      <g>
                        <polygon
                          fill="none"
                          points="14 10.8 7 10.8 3 13.8 3 10.8 1 10.8 1 1.2 14 1.2"
                          stroke-linejoin="round"
                          stroke-miterlimit="10"
                        ></polygon>
                        <circle cx="4" cy="5.8" r="1" stroke="none"></circle>
                        <circle cx="7.5" cy="5.8" r="1" stroke="none"></circle>
                        <circle cx="11" cy="5.8" r="1" stroke="none"></circle>
                      </g>
                    </svg>
                    <span class="exclude">
                      {{ sellers.items[0].response }}
                    </span>
                  </div>
                  <div class="item-text exclude">
                    聊聊回应率
                  </div>
                </div>
              </div>
              <div class="shop-statistics-item">
                <div class="shop-statistics-item-wrapper exclude">
                  <div class="item-header exclude">
                    <svg
                      enable-background="new 0 0 15 15"
                      viewBox="0 0 15 15"
                      x="0"
                      y="0"
                      class="shopee-svg-icon exclude"
                    >
                      <g>
                        <polyline
                          fill="none"
                          points="7.2 3.5 7.2 7.8 10.5 7.8"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-miterlimit="10"
                        ></polyline>
                        <circle
                          cx="7.5"
                          cy="7.5"
                          fill="none"
                          r="6.5"
                          stroke-miterlimit="10"
                        ></circle>
                      </g>
                    </svg>
                    <span class="exclude">
                      {{ sellers.items[0].responseTime }}
                    </span>
                  </div>
                  <div class="item-text exclude">
                    回应速度
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="section-title">
            <div class="section-title-txt exclude">
              <div class="icon exclude">
                <svg
                  width="16"
                  height="22"
                  viewBox="0 0 18 24"
                  class="shopee-svg-icon icon-hint-bulb exclude"
                >
                  <g transform="translate(-355 -149)">
                    <g transform="translate(355 149)">
                      <g
                        fill-rule="nonzero"
                        transform="translate(5.4 19.155556)"
                      >
                        <path
                          d="m1.08489412 1.77777778h5.1879153c.51164401 0 .92641344-.39796911.92641344-.88888889s-.41476943-.88888889-.92641344-.88888889h-5.1879153c-.51164402 0-.92641345.39796911-.92641345.88888889s.41476943.88888889.92641345.88888889z"
                        ></path>
                        <g transform="translate(1.9 2.666667)">
                          <path
                            d="m .75 1.77777778h2.1c.41421356 0 .75-.39796911.75-.88888889s-.33578644-.88888889-.75-.88888889h-2.1c-.41421356 0-.75.39796911-.75.88888889s.33578644.88888889.75.88888889z"
                          ></path>
                        </g>
                      </g>
                      <path
                        d="m8.1 8.77777718v4.66666782c0 .4295545.40294373.7777772.9.7777772s.9-.3482227.9-.7777772v-4.66666782c0-.42955447-.40294373-.77777718-.9-.77777718s-.9.34822271-.9.77777718z"
                        fill-rule="nonzero"
                      ></path>
                      <path
                        d="m8.1 5.33333333v.88889432c0 .49091978.40294373.88888889.9.88888889s.9-.39796911.9-.88888889v-.88889432c0-.49091977-.40294373-.88888889-.9-.88888889s-.9.39796912-.9.88888889z"
                        fill-rule="nonzero"
                      ></path>
                      <path
                        d="m8.80092773 0c-4.86181776 0-8.80092773 3.97866667-8.80092773 8.88888889 0 1.69422221.47617651 3.26933331 1.295126 4.61333331l2.50316913 3.9768889c.30201078.4782222.84303623.7697778 1.42482388.7697778h7.17785139c.7077799 0 1.3618277-.368 1.7027479-.9617778l2.3252977-4.0213333c.7411308-1.2888889 1.1728395-2.7786667 1.1728395-4.37688891 0-4.91022222-3.9409628-8.88888889-8.80092777-8.88888889m0 1.77777778c3.82979317 0 6.94810087 3.18933333 6.94810087 7.11111111 0 1.24444441-.3168334 2.43022221-.9393833 3.51466671l-2.3252977 4.0213333c-.0166754.0284444-.0481735.0462222-.0833772.0462222h-7.07224026l-2.43461454-3.8648889c-.68184029-1.12-1.04128871-2.4053333-1.04128871-3.71733331 0-3.92177778 3.11645483-7.11111111 6.94810084-7.11111111"
                      ></path>
                    </g>
                  </g>
                </svg>
              </div>
              <div class="keyword exclude">
                "<span class="exclude">{{ products.axiosParams.keyword }}</span
                >"
              </div>
              <div class="txt exclude">
                搜索的结果
              </div>
            </div>
          </div>
          <div class="filter-wrap exclude">
            <div class="filter-condition">
              <div class="label exclude">
                筛选
              </div>
              <div class="condition-items exclude">
                <div class="item active exclude">
                  综合排名
                </div>
              </div>
            </div>
            <div class="pagination-wrap">
              <div class="num exclude">
                <span class="current exclude">
                  {{ products.pagiation.current }}
                </span>
                /
                <span class="total exclude">
                  {{
                    Math.ceil(products.items.length / products.pagiation.count)
                  }}
                </span>
              </div>
              <div class="prev-next exclude noerror">
                <div
                  class="prev btn exclude noerror"
                  :class="{ disabled: products.pagiation.current === 1 }"
                  @click="
                    products.pagiation.current > 1
                      ? products.pagiation.current--
                      : ''
                  "
                >
                  <i class="el-icon-arrow-left exclude noerror"></i>
                </div>
                <div
                  class="next btn exclude noerror"
                  @click="
                    () => {
                      Math.ceil(
                        products.items.length / products.pagiation.count
                      ) > products.pagiation.current
                        ? products.pagiation.current++
                        : '';
                    }
                  "
                >
                  <i class="el-icon-arrow-right exclude noerror"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="product-wrapper exclude">
            <a
              href="javascript:;"
              class="product-item"
              v-for="(item, index) in productItems"
              :key="index"
            >
              <div class="product-img">
                <img :src="item.image" alt="" />
              </div>
              <div class="product-details exclude">
                <div class="product-title" :title="item.title">
                  {{ item.title }}
                </div>
                <div class="product-seller">
                  <span v-for="label in item.labels" :key="label">
                    {{ label }}
                  </span>
                </div>
                <div
                  :class="
                    activeItem === '#location-item-1' &&
                    items[activeItem].actived &&
                    items[activeItem].isActive
                      ? 'mark animate__animated animate__flash animate__repeat-2'
                      : ''
                  "
                  id="product-price"
                  class="product-price"
                >
                  {{ item.salePrice }}
                </div>
                <div>
                  <el-rate
                    :value="item.star"
                    :colors="['#99A9BF', '#F7BA2A', '#FF9900']"
                  >
                  </el-rate>
                </div>
                <div
                  style="font-size: 12px;display: flex;justify-content: space-between;color:#9e9e9e"
                >
                  <span>评论 {{ item.review }}</span>
                  <span>{{ item.soldNum }} sold</span>
                </div>
                <div class="product-shop">
                  {{ item.place }}
                </div>
                <div>
                  <a style="font-size: 12px" :href="item.url" target="_blank"
                    >shopee链接</a
                  >
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div v-show="hid" class="main-container">
      <div class="main-container-view">
        <div class="seller-content">
          <div class="section-title exclude" style="margin-bottom: 0">
            <div class="section-title-txt">
              <div class="keyword exclude">
                "<span class="exclude">Tea</span>"
              </div>
              <div class="txt exclude">
                相关的卖场
              </div>
            </div>
            <div class="more-link exclude noerror" @click="back" id="back">
              <span class="exclude noerror">返回</span>
              <i class="el-icon-arrow-right exclude noerror"></i>
            </div>
          </div>
          <div
            :class="
              activeItem === '#location-item-3' &&
              items[activeItem].actived &&
              items[activeItem].isActive
                ? 'mark animate__animated animate__flash animate__repeat-2'
                : ''
            "
            id="seller-items"
            class="seller-item"
            v-for="(item, index) in sellers.items"
            :key="index"
          >
            <div class="shop-img">
              <img :src="item.logo" alt="" />
            </div>
            <div class="shop-info exclude">
              <div class="info-item-nickname">
                {{ item.nickName }}
              </div>
              <div class="info-item-username">
                {{ item.userName }}
              </div>
              <div class="info-item-follow">
                {{ item.follow }}
              </div>
            </div>
            <div class="shop-statistics exclude">
              <div class="shop-statistics-item">
                <div class="shop-statistics-item-wrapper exclude">
                  <div class="item-header exclude">
                    <svg
                      style="width: 14px;height: 14px"
                      enable-background="new 0 0 15 15"
                      viewBox="0 0 15 15"
                      x="0"
                      y="0"
                      class="shopee-svg-icon icon-products exclude"
                    >
                      <g>
                        <path
                          d="m10 1 4.5 2.5-.5 3h-2v7.5h-9v-7.5h-2l-.5-3 4.6-2.5c.3 1.1 1.3 1.9 2.4 1.9s2.1-.8 2.5-1.9z"
                          fill="none"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-miterlimit="10"
                        ></path>
                        <line
                          fill="none"
                          stroke-linecap="round"
                          stroke-miterlimit="10"
                          x1="3"
                          x2="12"
                          y1="11.5"
                          y2="11.5"
                        ></line>
                      </g>
                    </svg>
                    <span class="exclude">
                      {{ item.products }}
                    </span>
                  </div>
                  <div class="item-text exclude">
                    商品
                  </div>
                </div>
              </div>
              <div class="shop-statistics-item">
                <div class="shop-statistics-item-wrapper exclude">
                  <div class="item-header exclude">
                    <svg
                      enable-background="new 0 0 15 15"
                      viewBox="0 0 15 15"
                      x="0"
                      y="0"
                      class="shopee-svg-icon icon-rating exclude"
                    >
                      <polygon
                        fill="none"
                        points="7.5 .8 9.7 5.4 14.5 5.9 10.7 9.1 11.8 14.2 7.5 11.6 3.2 14.2 4.3 9.1 .5 5.9 5.3 5.4"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-miterlimit="10"
                      ></polygon>
                    </svg>
                    <span class="exclude">
                      {{ item.comment }}
                    </span>
                  </div>
                  <div class="item-text exclude">
                    商品评价
                  </div>
                </div>
              </div>
              <div class="shop-statistics-item">
                <div class="shop-statistics-item-wrapper exclude">
                  <div class="item-header exclude">
                    <svg
                      enable-background="new 0 0 15 15"
                      viewBox="0 0 15 15"
                      x="0"
                      y="0"
                      class="shopee-svg-icon exclude "
                    >
                      <g>
                        <polygon
                          fill="none"
                          points="14 10.8 7 10.8 3 13.8 3 10.8 1 10.8 1 1.2 14 1.2"
                          stroke-linejoin="round"
                          stroke-miterlimit="10"
                        ></polygon>
                        <circle cx="4" cy="5.8" r="1" stroke="none"></circle>
                        <circle cx="7.5" cy="5.8" r="1" stroke="none"></circle>
                        <circle cx="11" cy="5.8" r="1" stroke="none"></circle>
                      </g>
                    </svg>
                    <span class="exclude">
                      {{ item.response }}
                    </span>
                  </div>
                  <div class="item-text exclude">
                    聊聊回应率
                  </div>
                </div>
              </div>
              <div class="shop-statistics-item">
                <div class="shop-statistics-item-wrapper exclude">
                  <div class="item-header exclude">
                    <svg
                      enable-background="new 0 0 15 15"
                      viewBox="0 0 15 15"
                      x="0"
                      y="0"
                      class="shopee-svg-icon exclude"
                    >
                      <g>
                        <polyline
                          fill="none"
                          points="7.2 3.5 7.2 7.8 10.5 7.8"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-miterlimit="10"
                        ></polyline>
                        <circle
                          cx="7.5"
                          cy="7.5"
                          fill="none"
                          r="6.5"
                          stroke-miterlimit="10"
                        ></circle>
                      </g>
                    </svg>
                    <span class="exclude">
                      {{ item.responseTime }}
                    </span>
                  </div>
                  <div class="item-text exclude">
                    回应速度
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["activeItem", "DriverInstance", "items"],
  data() {
    return {
      hid: false,
      search: "Tea",
      products: {
        loading: false,
        items: [
          {
            country: "马来西亚",
            tea: "大红袍",
            image:
              "https://cf.shopee.com.my/file/1de3a214d63451795be165637f46e29f_tn",
            sold: "19 sold",
            create_time: 1637748869000,
            salePrice: "RM3.00",
            price: "",
            product_id: 96,
            place: "Selangor",
            title:
              "【一罐茶】九味口粮茶 绿茶 茉莉花茶  碧螺春 铁观音 大红袍 正山小种 正岩肉桂 金骏眉 普洱茶 | Chinese Tea | Chinese Can Tea | Chinese Cup Tea |ShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//【一罐茶】九味口粮茶-绿茶-茉莉花茶-碧螺春-铁观音-大红袍-正山小种-正岩肉桂-金骏眉-普洱茶-Chinese-Tea-Chinese-Can-Tea-Chinese-Cup-Tea--i.521239025.8291353601?sp_atk=702a7bf5-b2e3-445a-a737-9c1a3817ae65",
            labels: [],
            soldNum: 1895,
            review: 118,
            star: 5,
          },
          {
            country: "马来西亚",
            tea: "正山小种",
            image:
              "https://cf.shopee.com.my/file/328c46669a26bf41c21aac0bdf7a7c99_tn",
            sold: "",
            create_time: 1637748869000,
            salePrice: "RM96.24 - RM113.63",
            price: "",
            product_id: 174,
            place: "Mainland China",
            title:
              "Is The Small Tea Gift Gold Jun Eyebrow Black 18 Cans 250g正山小种茶叶 高档礼盒装送礼 金骏眉红茶大红袍浓香型18罐共250gbycgrrfsa.my10.19",
            url:
              "https://my.xiapibuy.com//Is-The-Small-Tea-Gift-Gold-Jun-Eyebrow-Black-18-Cans-250g正山小种茶叶-高档礼盒装送礼-金骏眉红茶大红袍浓香型18罐共250gbycgrrfsa.my10.19-i.415314684.13831363417?sp_atk=78d46b79-cce2-4006-a31d-c222e2665dba",
            labels: [],
            soldNum: 2090,
            review: 116,
            star: 5,
          },
          {
            country: "马来西亚",
            tea: "大红袍",
            image:
              "https://cf.shopee.com.my/file/f07f03d8d5e404a423fcb0a7389a82f8_tn",
            sold: "118 sold",
            create_time: 1637748869000,
            salePrice: "RM8.90",
            price: "RM9.50",
            product_id: 78,
            place: "Kuala Lumpur",
            title:
              "????现货????精美铁盒+单独包装 中国茶 大红袍 铁观音 普洱熟茶 黑乌龙 龙井茶 小种红茶 茉莉花茶 高山绿茶 炭焙铁观音 碧螺春 金俊眉 Chinese Tea Da Hong Pao Puer Tie Guan YinShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//????现货????精美铁盒-单独包装-中国茶-大红袍-铁观音-普洱熟茶-黑乌龙-龙井茶-小种红茶-茉莉花茶-高山绿茶-炭焙铁观音-碧螺春-金俊眉-Chinese-Tea-Da-Hong-Pao-Puer-Tie-Guan-Yin-i.128031579.12917419602?sp_atk=168b3483-9b28-4c67-a2d6-71ce5ffa2128",
            labels: [],
            soldNum: 1285,
            review: 67,
            star: 4,
          },
          {
            country: "马来西亚",
            tea: "茉莉花",
            image:
              "https://cf.shopee.com.my/file/dbe9ce38639734cc39ca5946c1629a60_tn",
            sold: "821 sold",
            create_time: 1637748869000,
            salePrice: "RM0.99",
            price: "RM1.45",
            product_id: 55,
            place: "Kuala Lumpur",
            title:
              "茉莉花茶袋装2020新茶浓香型特级毛尖  茉莉花茶小包装茶一包 jasmine teaShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//茉莉花茶袋装2020新茶浓香型特级毛尖-茉莉花茶小包装茶一包-jasmine-tea-i.10534598.4574525715?sp_atk=2db2e89c-da83-4a2e-b8be-5c29403f677f",
            labels: [],
            soldNum: 3724,
            review: 372,
            star: 5,
          },
          {
            country: "马来西亚",
            tea: "大红袍",
            image:
              "https://cf.shopee.com.my/file/57d7a2ec7129eb4a79da5438d3606fb4_tn",
            sold: "541 sold",
            create_time: 1637748869000,
            salePrice: "RM17.10",
            price: "RM24.42",
            product_id: 113,
            place: "Kuala Lumpur",
            title:
              "大红袍茶叶 武夷岩茶 试喝装 奇兰 水仙 肉桂 矮脚乌龙茶 浓香型16口味128g Assorted tea 16 flavorsShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//大红袍茶叶-武夷岩茶-试喝装-奇兰-水仙-肉桂-矮脚乌龙茶-浓香型16口味128g-Assorted-tea-16-flavors-i.266929667.4162348297?sp_atk=f2a6630d-15c8-4fe3-b1f5-60a79258f68e",
            labels: [],
            soldNum: 2494,
            review: 207,
            star: 4,
          },
          {
            country: "马来西亚",
            tea: "正山小种",
            image:
              "https://cf.shopee.com.my/file/9cab3e881c7499a4c173153a657e254d_tn",
            sold: "4 sold",
            create_time: 1637748869000,
            salePrice: "RM34.60",
            price: "RM86.65",
            product_id: 139,
            place: "Mainland China",
            title:
              "【品茶】十大名茶组合套装 白茶 红茶 金骏眉 正山小种 龙井 铁观音 肉桂 茉莉花茶 黑乌龙茶 大红袍 Top Ten Famous Tea Combination Set White Tea Black Tea Jinjunmei Zhengshan Race Longjing Tieguanyin Cinnamon Jasmine Tea Black Oolong Tea Dahongpao.RM2 offCOD",
            url:
              "https://my.xiapibuy.com//【品茶】十大名茶组合套装-白茶-红茶-金骏眉-正山小种-龙井-铁观音-肉桂-茉莉花茶-黑乌龙茶-大红袍-Top-Ten-Famous-Tea-Combination-Set-White-Tea-Black-Tea-Jinjunmei-Zhengshan-Race-Longjing-Tieguanyin-Cinnamon-Jasmine-Tea-Black-Oolong-Tea-Dahongpao.-i.513884826.10046177133?sp_at",
            labels: [],
            soldNum: 2769,
            review: 173,
            star: 3,
          },
          {
            country: "马来西亚",
            tea: "茉莉花",
            image:
              "https://cf.shopee.com.my/file/b213ca24a3ad0ebba19b92ce02bcd1f8_tn",
            sold: "186 sold",
            create_time: 1637748869000,
            salePrice: "RM2.98",
            price: "RM5.88",
            product_id: 28,
            place: "Kuala Lumpur",
            title:
              "【九零食代】农夫山泉 茶兀 茶π 茶派 网红爆款 饮料 Nongfu Spring Cha Pai Fruit Tea 500ml 蜜桃乌龙茶 / 柚子绿茶 / 柠檬红茶 / 西柚茉莉花茶ShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//【九零食代】农夫山泉-茶兀-茶π-茶派-网红爆款-饮料-Nongfu-Spring-Cha-Pai-Fruit-Tea-500ml-蜜桃乌龙茶-柚子绿茶-柠檬红茶-西柚茉莉花茶-i.535543179.11548199571?sp_atk=c142ff93-0555-4b2f-903c-d1f4b8177507",
            labels: [],
            soldNum: 1122,
            review: 112,
            star: 4,
          },
          {
            country: "马来西亚",
            tea: "茉莉花",
            image:
              "https://cf.shopee.com.my/file/135ab7bf756aae97351c3c7db1f17ed7_tn",
            sold: "1 sold",
            create_time: 1637748869000,
            salePrice: "RM16.00 - RM30.00",
            price: "",
            product_id: 23,
            place: "Kuala Lumpur",
            title:
              "【翟潇闻同款】fnf 原萃茶饮 冷泡果茶 浓缩液 Fruit Tea 柠檬红茶 蜜桃乌龙茶 葡萄茉莉花茶 西柚茉莉花茶 百香果乌龙茶 Passion fruit Oolong tea Grapefruit Jasmine tea Grape24% offShopMalaysia",
            url:
              "https://my.xiapibuy.com//【翟潇闻同款】fnf-原萃茶饮-冷泡果茶-浓缩液-Fruit-Tea-柠檬红茶-蜜桃乌龙茶-葡萄茉莉花茶-西柚茉莉花茶-百香果乌龙茶-Passion-fruit-Oolong-tea-Grapefruit-Jasmine-tea-Grape-i.456306598.13531574732?sp_atk=d124e7c2-041a-4942-8644-1807ef9e466c",
            labels: [],
            soldNum: 2943,
            review: 196,
            star: 3,
          },
          {
            country: "马来西亚",
            tea: "大红袍",
            image:
              "https://cf.shopee.com.my/file/49e96ba1eb1bf73f61830711a4118a29_tn",
            sold: "9 sold",
            create_time: 1637748869000,
            salePrice: "RM7.89 - RM9.99",
            price: "",
            product_id: 84,
            place: "Johor",
            title:
              "金骏眉铁观音茶叶茉莉花茶大红袍组合茶 Jin Junmei Tieguanyin Tea Jasmine Tea Dahongpao Combination TeaShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//金骏眉铁观音茶叶茉莉花茶大红袍组合茶-Jin-Junmei-Tieguanyin-Tea-Jasmine-Tea-Dahongpao-Combination-Tea-i.252245248.11041292944?sp_atk=2429d67c-777b-45ef-bf01-5a1cd9093bb2",
            labels: [],
            soldNum: 4820,
            review: 438,
            star: 4,
          },
          {
            country: "马来西亚",
            tea: "茉莉花",
            image:
              "https://cf.shopee.com.my/file/d5956e3bfc1ee67635b471d3c2e45528_tn",
            sold: "32k sold",
            create_time: 1637748869000,
            salePrice: "RM2.85 - RM2.89",
            price: "",
            product_id: 58,
            place: "Selangor",
            title:
              "农夫山泉茶π Nongfu Spring Cha Pai Cha Pie 茶π 茶派 Fruit Tea 500mlShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//农夫山泉茶π-Nongfu-Spring-Cha-Pai-Cha-Pie-茶π-茶派-Fruit-Tea-500ml-i.239158017.5722151393?sp_atk=9f90d48a-2854-4189-9a82-298da32a058e",
            labels: [],
            soldNum: 631,
            review: 52,
            star: 5,
          },
          {
            country: "马来西亚",
            tea: "大红袍",
            image:
              "https://cf.shopee.com.my/file/1999bd3a73986d42d9ab5977778cdf8d_tn",
            sold: "27 sold",
            create_time: 1637748869000,
            salePrice: "RM45.00",
            price: "RM50.00",
            product_id: 85,
            place: "Selangor",
            title:
              "岩骨花香大红袍 Yan Gu Hua Xiang Da Hong Pao 【25packs x 10g】|【 武夷岩茶 Wu Yi Rock Tea 】乌龙茶 Oolong tea | Teh Cina 中国茶叶 Chinese TeaShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//岩骨花香大红袍-Yan-Gu-Hua-Xiang-Da-Hong-Pao-【25packs-x-10g】-【-武夷岩茶-Wu-Yi-Rock-Tea-】乌龙茶-Oolong-tea-Teh-Cina-中国茶叶-Chinese-Tea-i.142200712.4154270551?sp_atk=081b14e7-298f-4b3d-a9c4-1c802e871431",
            labels: [],
            soldNum: 4205,
            review: 262,
            star: 4,
          },
          {
            country: "马来西亚",
            tea: "茉莉花",
            image:
              "https://cf.shopee.com.my/file/e73eda431ba159412e62972de2e0834d_tn",
            sold: "",
            create_time: 1637748869000,
            salePrice: "RM11.00 - RM14.00",
            price: "",
            product_id: 15,
            place: "Selangor",
            title:
              "精美铁罐 三角茶包 水果 花茶 Healthy Flower Fruit Tea Can 蜜桃乌龙茶 蔓越莓 茉莉 玄米绿茶 冬瓜荷叶茶 Japanese Jasmine Green Tea Peach Oolong CranberryShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//精美铁罐-三角茶包-水果-花茶-Healthy-Flower-Fruit-Tea-Can-蜜桃乌龙茶-蔓越莓-茉莉-玄米绿茶-冬瓜荷叶茶-Japanese-Jasmine-Green-Tea-Peach-Oolong-Cranberry-i.9084405.13817598112?sp_atk=b0221ea2-dd61-41c2-8202-eaa736fb610e",
            labels: [],
            soldNum: 1516,
            review: 101,
            star: 5,
          },
          {
            country: "马来西亚",
            tea: "正山小种",
            image:
              "https://cf.shopee.com.my/file/8daf4ce2a80b8917f04a3b708c416983_tn",
            sold: "41 sold",
            create_time: 1637748869000,
            salePrice: "RM78.84 - RM294.84",
            price: "",
            product_id: 131,
            place: "Johor",
            title:
              "【红茶】云南古树红茶 正山小种 金骏眉   50克 降血糖、降血压、降血脂、防治心肌梗塞  【Red Tea】Yunnan Red Tea  50gShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//【红茶】云南古树红茶-正山小种-金骏眉-50克-降血糖、降血压、降血脂、防治心肌梗塞-【Red-Tea】Yunnan-Red-Tea-50g-i.305390642.3757147560?sp_atk=3695fdac-a657-4be4-8b51-a847fd15345e",
            labels: [],
            soldNum: 2350,
            review: 195,
            star: 4,
          },
          {
            country: "马来西亚",
            tea: "大红袍",
            image:
              "https://cf.shopee.com.my/file/605fd96b57057eb74259ebf0e4aac3fd_tn",
            sold: "15.1k sold",
            create_time: 1637748869000,
            salePrice: "RM0.48 - RM0.59",
            price: "",
            product_id: 98,
            place: "Perak",
            title:
              "【Ready Stock，现货】茶叶中国浓香型热卖茶叶：铁观音，龙井茶，普洱茶，茉莉花茶，高山绿茶，大红袍茶，黑乌龙茶 (Hot-selling Chinese tea with strong flavor: Tieguanyin etc）ShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//【Ready-Stock，现货】茶叶中国浓香型热卖茶叶：铁观音，龙井茶，普洱茶，茉莉花茶，高山绿茶，大红袍茶，黑乌龙茶-(Hot-selling-Chinese-tea-with-strong-flavor-Tieguanyin-etc）-i.171504495.9139346773?sp_atk=ec19ab6c-3e4b-4f03-b3ce-2d2c1f793274",
            labels: [],
            soldNum: 3777,
            review: 188,
            star: 4,
          },
          {
            country: "马来西亚",
            tea: "正山小种",
            image:
              "https://cf.shopee.com.my/file/81b5b49c12b319e3571e5cf271be2936_tn",
            sold: "3 sold",
            create_time: 1637748869000,
            salePrice: "RM9.90",
            price: "RM24.00",
            product_id: 125,
            place: "Kuala Lumpur",
            title:
              "Lapsang Souchong Tea正山小种茶（50gX10小包）ShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//Lapsang-Souchong-Tea正山小种茶（50gX10小包）-i.278239141.10904406225?sp_atk=eddae625-eb54-437e-95d9-d372ebf293f8",
            labels: [],
            soldNum: 1691,
            review: 99,
            star: 5,
          },
          {
            country: "马来西亚",
            tea: "茉莉花",
            image:
              "https://cf.shopee.com.my/file/15d3d2593f2d8359f1bad56320c840e6_tn",
            sold: "12 sold",
            create_time: 1637748869000,
            salePrice: "RM6.50 - RM8.90",
            price: "",
            product_id: 25,
            place: "Negeri Sembilan",
            title:
              "【花茶系列】Premium Chrysanthemums Buds 胎菊/France Rose 法国玫瑰/Jasmine Tea 茉莉花茶/Osmanthus Flower 桂花/Gynostemma Pentaphyllum 绞股蓝ShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//【花茶系列】Premium-Chrysanthemums-Buds-胎菊-France-Rose-法国玫瑰-Jasmine-Tea-茉莉花茶-Osmanthus-Flower-桂花-Gynostemma-Pentaphyllum-绞股蓝-i.268027425.7171736459?sp_atk=89d97a18-6ece-42a0-b3d1-1af579db8377",
            labels: [],
            soldNum: 4508,
            review: 450,
            star: 5,
          },
          {
            country: "马来西亚",
            tea: "茉莉花",
            image:
              "https://cf.shopee.com.my/file/086acfa818c7f5ac7c3d5ceea157457b_tn",
            sold: "",
            create_time: 1637748869000,
            salePrice: "RM15.99",
            price: "RM16.50",
            product_id: 33,
            place: "Melaka",
            title:
              "铁罐装茶叶 碧螺春 普洱茶 正山小种 金骏眉 茉莉花茶 铁观音 绿茶 大红袍 中国茶叶 #chinese tea #各类式 #名茶 #浓香ShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//铁罐装茶叶-碧螺春-普洱茶-正山小种-金骏眉-茉莉花茶-铁观音-绿茶-大红袍-中国茶叶-chinese-tea-各类式-名茶-浓香-i.396483765.10770414275?sp_atk=35cdb236-5ed4-4c32-98f8-c9fc3d593c08",
            labels: [],
            soldNum: 3617,
            review: 226,
            star: 5,
          },
          {
            country: "马来西亚",
            tea: "茉莉花",
            image:
              "https://cf.shopee.com.my/file/49e96ba1eb1bf73f61830711a4118a29_tn",
            sold: "9 sold",
            create_time: 1637748869000,
            salePrice: "RM7.89 - RM9.99",
            price: "",
            product_id: 20,
            place: "Johor",
            title:
              "金骏眉铁观音茶叶茉莉花茶大红袍组合茶 Jin Junmei Tieguanyin Tea Jasmine Tea Dahongpao Combination TeaShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//金骏眉铁观音茶叶茉莉花茶大红袍组合茶-Jin-Junmei-Tieguanyin-Tea-Jasmine-Tea-Dahongpao-Combination-Tea-i.252245248.11041292944?sp_atk=08dc7b9c-5236-4510-ba85-b7b72cf2a082",
            labels: [],
            soldNum: 1969,
            review: 140,
            star: 5,
          },
          {
            country: "马来西亚",
            tea: "大红袍",
            image:
              "https://cf.shopee.com.my/file/371c0fe6f8d9acd8622bbaf375511a89_tn",
            sold: "264 sold",
            create_time: 1637748869000,
            salePrice: "RM61.88 - RM302.64",
            price: "",
            product_id: 62,
            place: "Johor",
            title:
              "【大红袍】武夷山正岩顶级大红袍茶 50克罐装 礼盒装 精选大红袍 高山乌龙茶 精美罐装 送礼佳品 绝对耐泡 Premium Da Hong Pao Wuyi Rock Tea 50gShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//【大红袍】武夷山正岩顶级大红袍茶-50克罐装-礼盒装-精选大红袍-高山乌龙茶-精美罐装-送礼佳品-绝对耐泡-Premium-Da-Hong-Pao-Wuyi-Rock-Tea-50g-i.305390642.3552510858?sp_atk=834af9db-f15b-42ac-a350-8fc700e02ec5",
            labels: [],
            soldNum: 1857,
            review: 92,
            star: 5,
          },
          {
            country: "马来西亚",
            tea: "正山小种",
            image:
              "https://cf.shopee.com.my/file/f1da5b1d2762f9a5bfc1b6df159f7907_tn",
            sold: "",
            create_time: 1637748869000,
            salePrice: "RM11.15 - RM47.23",
            price: "",
            product_id: 143,
            place: "Melaka",
            title:
              "Lapsang Souchong authentic black tea 202正山小种正宗红茶2021新茶浓香型茶叶暖胃茶叶非特级做奶茶lrw3f3ycn7Local SellerCOD",
            url:
              "https://my.xiapibuy.com//Lapsang-Souchong-authentic-black-tea-202正山小种正宗红茶2021新茶浓香型茶叶暖胃茶叶非特级做奶茶lrw3f3ycn7-i.431042679.13003973806?sp_atk=43420f55-ec06-4524-b3b4-32da82685b43",
            labels: [],
            soldNum: 1545,
            review: 110,
            star: 4,
          },
          {
            country: "马来西亚",
            tea: "茉莉花",
            image:
              "https://cf.shopee.com.my/file/8c18b0cafb0ee0b9260b3a99e5330631_tn",
            sold: "7 sold",
            create_time: 1637748869000,
            salePrice: "RM23.75 - RM47.50",
            price: "",
            product_id: 17,
            place: "Selangor",
            title:
              "????????????High Quality Jasmine Tea Chinese Tea Kobicha Tea 茉莉花茶 中国名茶 媚茶RM2 offShopMalaysia",
            url:
              "https://my.xiapibuy.com//????????????High-Quality-Jasmine-Tea-Chinese-Tea-Kobicha-Tea-茉莉花茶-中国名茶-媚茶-i.255098748.8190269696?sp_atk=45a8b650-5da4-4b17-b79c-e269ef33178a",
            labels: [],
            soldNum: 1077,
            review: 76,
            star: 5,
          },
          {
            country: "马来西亚",
            tea: "正山小种",
            image:
              "https://cf.shopee.com.my/file/d03aedce405b4801c268768f7aa9246d_tn",
            sold: "50 sold",
            create_time: 1637748869000,
            salePrice: "RM0.58",
            price: "",
            product_id: 157,
            place: "Melaka",
            title:
              "茶叶 小袋 散装包 普洱茶 碧螺春 毛尖茶 黄金桂 铁观音 绿茶 正山小种 金丝皇菊 茉莉花茶 黑乌龙茶 大红袍 龙井 炭焙铁观音 金骏眉 中国茶叶 #浓香 #现货 #chinese tea pack #ShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//茶叶-小袋-散装包-普洱茶-碧螺春-毛尖茶-黄金桂-铁观音-绿茶-正山小种-金丝皇菊-茉莉花茶-黑乌龙茶-大红袍-龙井-炭焙铁观音-金骏眉-中国茶叶-浓香-现货-chinese-tea-pack--i.396483765.12247654293?sp_atk=837f5b02-8530-4d2f-9f88-a39e8825e88f",
            labels: [],
            soldNum: 4738,
            review: 296,
            star: 4,
          },
          {
            country: "马来西亚",
            tea: "大红袍",
            image:
              "https://cf.shopee.com.my/file/11bd3f8dc4ba315ae2613c3edbae2102_tn",
            sold: "327 sold",
            create_time: 1637748869000,
            salePrice: "RM9.90",
            price: "RM13.00",
            product_id: 112,
            place: "Selangor",
            title:
              "茶叶 2021 New Chinese Tea 铁观音 大红袍 金骏眉 高山绿茶 碧螺春 普洱熟茶 龙井 Tie Guan Yin Da Hong Pao Puer teh Jasmine teaShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//茶叶-2021-New-Chinese-Tea-铁观音-大红袍-金骏眉-高山绿茶-碧螺春-普洱熟茶-龙井-Tie-Guan-Yin-Da-Hong-Pao-Puer-teh-Jasmine-tea-i.10462357.6974073771?sp_atk=b48e8e5d-4f6c-468c-8e99-a725e35c59c4",
            labels: [],
            soldNum: 3932,
            review: 206,
            star: 4,
          },
          {
            country: "马来西亚",
            tea: "茉莉花",
            image:
              "https://cf.shopee.com.my/file/dc097be3d72532ade25af899ea06131e_tn",
            sold: "10 sold",
            create_time: 1637748869000,
            salePrice: "RM16.90",
            price: "",
            product_id: 60,
            place: "Pahang",
            title:
              "茉莉薄荷茶(30包)Jasmine Mint Tea 90gShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//茉莉薄荷茶(30包)Jasmine-Mint-Tea-90g-i.39251387.9910850233?sp_atk=f9b00f31-a87a-47b2-b1b2-be8e70c29c7e",
            labels: [],
            soldNum: 153,
            review: 13,
            star: 5,
          },
          {
            country: "马来西亚",
            tea: "茉莉花",
            image:
              "https://cf.shopee.com.my/file/44b8a3c3b639d0d6d22b2078f92653c7_tn",
            sold: "5 sold",
            create_time: 1637748869000,
            salePrice: "RM4.99 - RM14.99",
            price: "",
            product_id: 51,
            place: "Kuala Lumpur",
            title:
              "Jasmine Flower Tea 茉莉花茶Jasmine Flower 茉莉花 Bunga Melati 30g~100gShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//Jasmine-Flower-Tea-茉莉花茶Jasmine-Flower-茉莉花-Bunga-Melati-30g~100g-i.145759214.6982277726?sp_atk=2cc483eb-99ca-4b20-b5e0-40aefe135252",
            labels: [],
            soldNum: 4006,
            review: 286,
            star: 4,
          },
          {
            country: "马来西亚",
            tea: "茉莉花",
            image:
              "https://cf.shopee.com.my/file/771d3735d8d99e93862033146450d88f_tn",
            sold: "1 sold",
            create_time: 1637748869000,
            salePrice: "RM55.80",
            price: "RM60.00",
            product_id: 1,
            place: "Selangor",
            title:
              "龙地山特级茉莉花茶 罐装送礼佳品 250克 LongDiShan Yun Nan Jasmine Tea 250g【现货 | Ready Stock】24% offShopMalaysia",
            url:
              "https://my.xiapibuy.com//龙地山特级茉莉花茶-罐装送礼佳品-250克-LongDiShan-Yun-Nan-Jasmine-Tea-250g【现货-Ready-Stock】-i.97541639.6297459534?sp_atk=c4fe9940-a57c-40ae-8c94-7d5badb9e41e",
            labels: [],
            soldNum: 3271,
            review: 218,
            star: 5,
          },
          {
            country: "马来西亚",
            tea: "大红袍",
            image:
              "https://cf.shopee.com.my/file/7c8d1ac5691ff08e8525c25271852f38_tn",
            sold: "28 sold",
            create_time: 1637748869000,
            salePrice: "RM35.00",
            price: "",
            product_id: 90,
            place: "Selangor",
            title:
              "奇兰香大红袍 Qi Lan Xiang Da Hong Pao 【100g】韵香 大红袍 武夷岩茶 Wu Yi Rock Tea Oolong tea |  Teh Cina  中国茶 中国茶叶 茶叶 Chinese TeaShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//奇兰香大红袍-Qi-Lan-Xiang-Da-Hong-Pao-【100g】韵香-大红袍-武夷岩茶-Wu-Yi-Rock-Tea-Oolong-tea-Teh-Cina-中国茶-中国茶叶-茶叶-Chinese-Tea-i.142200712.11440423238?sp_atk=f77cd0ec-f6b9-4629-98e8-ad5d4d0fe166",
            labels: [],
            soldNum: 3314,
            review: 236,
            star: 4,
          },
          {
            country: "马来西亚",
            tea: "正山小种",
            image:
              "https://cf.shopee.com.my/file/4fdf2ada49151286a0300f84c2f7e310_tn",
            sold: "",
            create_time: 1637748869000,
            salePrice: "RM22.00 - RM42.00",
            price: "",
            product_id: 165,
            place: "Mainland China",
            title:
              "New tea authentic Dahongpao Jinjunmei Tieguanyin Zhengshan small Biluochun old w新茶 正宗大红袍金骏眉铁观音正山小种碧螺春老白茶 茶叶罐装jiumei10.my21.10.14RM2 off",
            url:
              "https://my.xiapibuy.com//New-tea-authentic-Dahongpao-Jinjunmei-Tieguanyin-Zhengshan-small-Biluochun-old-w新茶-正宗大红袍金骏眉铁观音正山小种碧螺春老白茶-茶叶罐装jiumei10.my21.10.14-i.427603284.11559332819?sp_atk=a021a318-6bec-44f6-a617-36b7d93cea8c",
            labels: [],
            soldNum: 4205,
            review: 210,
            star: 3,
          },
          {
            country: "马来西亚",
            tea: "正山小种",
            image:
              "https://cf.shopee.com.my/file/07ba9873b778611fc0de3219cb4350c9_tn",
            sold: "",
            create_time: 1637748869000,
            salePrice: "RM18.25 - RM71.89",
            price: "",
            product_id: 175,
            place: "Labuan",
            title:
              "flavor made milk tea leaves in loose bags正山小种新茶正宗红茶武夷暖胃2021新茶浓香型做奶茶叶散袋装1b3gp6shph9.23Local SellerCOD",
            url:
              "https://my.xiapibuy.com//flavor-made-milk-tea-leaves-in-loose-bags正山小种新茶正宗红茶武夷暖胃2021新茶浓香型做奶茶叶散袋装1b3gp6shph9.23-i.431087996.13214917188?sp_atk=44baddf4-68f3-4640-85fb-97a9bec3b0c6",
            labels: [],
            soldNum: 4693,
            review: 361,
            star: 4,
          },
          {
            country: "马来西亚",
            tea: "茉莉花",
            image:
              "https://cf.shopee.com.my/file/c71fd2092269f39679125e7b6197609c_tn",
            sold: "395 sold",
            create_time: 1637748869000,
            salePrice: "RM7.80 - RM7.95",
            price: "",
            product_id: 14,
            place: "Selangor",
            title:
              "Ready Stock☕️Healthy Flower Fruit Tea Can  Oolong Tea Peach Tea Lemon Tea 桂圆红枣枸杞茶蜜桃乌龙茶茉莉花茶ShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//Ready-Stock☕️Healthy-Flower-Fruit-Tea-Can-Oolong-Tea-Peach-Tea-Lemon-Tea-桂圆红枣枸杞茶蜜桃乌龙茶茉莉花茶-i.11045591.4679792991?sp_atk=f7e33ac6-127d-42f6-bc62-214e6298a0a8",
            labels: [],
            soldNum: 305,
            review: 20,
            star: 5,
          },
          {
            country: "马来西亚",
            tea: "大红袍",
            image:
              "https://cf.shopee.com.my/file/9cab3e881c7499a4c173153a657e254d_tn",
            sold: "4 sold",
            create_time: 1637748869000,
            salePrice: "RM34.60",
            price: "RM86.65",
            product_id: 87,
            place: "Mainland China",
            title:
              "【品茶】十大名茶组合套装 白茶 红茶 金骏眉 正山小种 龙井 铁观音 肉桂 茉莉花茶 黑乌龙茶 大红袍 Top Ten Famous Tea Combination Set White Tea Black Tea Jinjunmei Zhengshan Race Longjing Tieguanyin Cinnamon Jasmine Tea Black Oolong Tea Dahongpao.RM2 offCOD",
            url:
              "https://my.xiapibuy.com//【品茶】十大名茶组合套装-白茶-红茶-金骏眉-正山小种-龙井-铁观音-肉桂-茉莉花茶-黑乌龙茶-大红袍-Top-Ten-Famous-Tea-Combination-Set-White-Tea-Black-Tea-Jinjunmei-Zhengshan-Race-Longjing-Tieguanyin-Cinnamon-Jasmine-Tea-Black-Oolong-Tea-Dahongpao.-i.513884826.10046177133?sp_at",
            labels: [],
            soldNum: 2310,
            review: 135,
            star: 4,
          },
          {
            country: "马来西亚",
            tea: "正山小种",
            image:
              "https://cf.shopee.com.my/file/5745001b1a2bed6e073a21c1a399f386_tn",
            sold: "3 sold",
            create_time: 1637748869000,
            salePrice: "RM10.90",
            price: "",
            product_id: 161,
            place: "Selangor",
            title: "Red Tea 正山小种金骏眉红茶 125gShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//Red-Tea-正山小种金骏眉红茶-125g-i.107485006.4586644324?sp_atk=6edb161b-833d-42ec-ad43-e99c4c9de32b",
            labels: [],
            soldNum: 1964,
            review: 115,
            star: 5,
          },
          {
            country: "马来西亚",
            tea: "正山小种",
            image:
              "https://cf.shopee.com.my/file/4f4cb5b8c6505eb4d513456e26b9536b_tn",
            sold: "162 sold",
            create_time: 1637748869000,
            salePrice: "RM15.88 - RM18.88",
            price: "",
            product_id: 132,
            place: "Selangor",
            title:
              "普洱茶 金骏眉 正山小种 大红袍 铁观音 茉莉花茶 高山绿茶 碧螺春 黄金桂茶 黑乌龙茶 龙景绿茶 毛尖 炭焙铁观音 奇兰 老叢水仙 肉桂 凤凰單叢 茶叶 chinese tea health Puer Da Hong Pao OolongShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//普洱茶-金骏眉-正山小种-大红袍-铁观音-茉莉花茶-高山绿茶-碧螺春-黄金桂茶-黑乌龙茶-龙景绿茶-毛尖-炭焙铁观音-奇兰-老叢水仙-肉桂-凤凰單叢-茶叶-chinese-tea-health-Puer-Da-Hong-Pao-Oolong-i.653343.9513923540?sp_atk=0197bc46-d343-438f-a4b2-2b335893a6ff",
            labels: [],
            soldNum: 3473,
            review: 347,
            star: 4,
          },
          {
            country: "马来西亚",
            tea: "大红袍",
            image:
              "https://cf.shopee.com.my/file/0bebf290d438cf85ff6a382255f73040_tn",
            sold: "18 sold",
            create_time: 1637748869000,
            salePrice: "RM9.90 - RM32.50",
            price: "",
            product_id: 77,
            place: "Mainland China",
            title:
              "新茶浓香大红袍茶叶罐装岩茶肉桂水仙乌龙茶New Tea Fragrant Dahongpao Tea Canned Rock Tea Cinnamon Narcissus Oolong TeaCODAdd-on Deal",
            url:
              "https://my.xiapibuy.com//新茶浓香大红袍茶叶罐装岩茶肉桂水仙乌龙茶New-Tea-Fragrant-Dahongpao-Tea-Canned-Rock-Tea-Cinnamon-Narcissus-Oolong-Tea-i.513884826.10730567114?sp_atk=013f40df-a2bf-4dbd-b488-74ab202b04d3",
            labels: [],
            soldNum: 194,
            review: 16,
            star: 3,
          },
          {
            country: "马来西亚",
            tea: "茉莉花",
            image:
              "https://cf.shopee.com.my/file/f27a5923c63a2503235c30afb34264a5_tn",
            sold: "9.7k sold",
            create_time: 1637748869000,
            salePrice: "RM0.45 - RM1.12",
            price: "",
            product_id: 36,
            place: "Perak",
            title:
              "【COH】养生茶 Flower Tea Teh Bunga 【壹间草药】Doorgift 花茶 养生花茶 红枣 菊花 玫瑰 山楂 柠檬 茉莉 桂圆 龙眼 决明子 枸杞 胎菊 金银花 瘦身 减肥 养肝茶 抗氧化 美白 祛痘ShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//【COH】养生茶-Flower-Tea-Teh-Bunga-【壹间草药】Doorgift-花茶-养生花茶-红枣-菊花-玫瑰-山楂-柠檬-茉莉-桂圆-龙眼-决明子-枸杞-胎菊-金银花-瘦身-减肥-养肝茶-抗氧化-美白-祛痘-i.26353660.4685937736?sp_atk=5ba01d24-0c62-4fb9-8d4b-193968bd5b69",
            labels: [],
            soldNum: 2033,
            review: 184,
            star: 5,
          },
          {
            country: "马来西亚",
            tea: "正山小种",
            image:
              "https://cf.shopee.com.my/file/1de3a214d63451795be165637f46e29f_tn",
            sold: "19 sold",
            create_time: 1637748869000,
            salePrice: "RM3.00",
            price: "",
            product_id: 166,
            place: "Selangor",
            title:
              "【一罐茶】九味口粮茶 绿茶 茉莉花茶  碧螺春 铁观音 大红袍 正山小种 正岩肉桂 金骏眉 普洱茶 | Chinese Tea | Chinese Can Tea | Chinese Cup Tea |ShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//【一罐茶】九味口粮茶-绿茶-茉莉花茶-碧螺春-铁观音-大红袍-正山小种-正岩肉桂-金骏眉-普洱茶-Chinese-Tea-Chinese-Can-Tea-Chinese-Cup-Tea--i.521239025.8291353601?sp_atk=722e5307-d30b-4536-92bd-02124bb87d51",
            labels: [],
            soldNum: 4547,
            review: 378,
            star: 5,
          },
          {
            country: "马来西亚",
            tea: "正山小种",
            image:
              "https://cf.shopee.com.my/file/26defe96920ac5ba06ff5b36245b5af1_tn",
            sold: "",
            create_time: 1637748869000,
            salePrice: "RM96.84",
            price: "",
            product_id: 151,
            place: "Selangor",
            title:
              "Tea 送茶具金骏眉红茶养胃正宗正山小种大红袍新茶批发茶叶礼盒装250g 0923Local SellerCOD",
            url:
              "https://my.xiapibuy.com//Tea-送茶具金骏眉红茶养胃正宗正山小种大红袍新茶批发茶叶礼盒装250g-0923-i.426356574.12414532334?sp_atk=b72e9508-97fb-49d7-8186-5bd20663410b",
            labels: [],
            soldNum: 780,
            review: 39,
            star: 3,
          },
          {
            country: "马来西亚",
            tea: "茉莉花",
            image:
              "https://cf.shopee.com.my/file/605fd96b57057eb74259ebf0e4aac3fd_tn",
            sold: "15.1k sold",
            create_time: 1637748869000,
            salePrice: "RM0.48 - RM0.59",
            price: "",
            product_id: 24,
            place: "Perak",
            title:
              "【Ready Stock，现货】茶叶中国浓香型热卖茶叶：铁观音，龙井茶，普洱茶，茉莉花茶，高山绿茶，大红袍茶，黑乌龙茶 (Hot-selling Chinese tea with strong flavor: Tieguanyin etc）ShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//【Ready-Stock，现货】茶叶中国浓香型热卖茶叶：铁观音，龙井茶，普洱茶，茉莉花茶，高山绿茶，大红袍茶，黑乌龙茶-(Hot-selling-Chinese-tea-with-strong-flavor-Tieguanyin-etc）-i.171504495.9139346773?sp_atk=9a652967-8a9f-464c-a62b-66000758b60b",
            labels: [],
            soldNum: 2813,
            review: 281,
            star: 5,
          },
          {
            country: "马来西亚",
            tea: "大红袍",
            image:
              "https://cf.shopee.com.my/file/f0a5bcd77aeb52d2e8ed230f68dc55f2_tn",
            sold: "274 sold",
            create_time: 1637748869000,
            salePrice: "RM13.12",
            price: "RM15.80",
            product_id: 80,
            place: "Kuala Lumpur",
            title:
              "大红袍 浓香型 盒装 （20小包）140g Da Hong Pao TeaShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//大红袍-浓香型-盒装-（20小包）140g-Da-Hong-Pao-Tea-i.266929667.7460866966?sp_atk=65ce40c4-c704-49bb-9c9d-801487364db0",
            labels: [],
            soldNum: 4248,
            review: 386,
            star: 3,
          },
          {
            country: "马来西亚",
            tea: "正山小种",
            image:
              "https://cf.shopee.com.my/file/719dbf2663f019a654a3458c82428ce2_tn",
            sold: "",
            create_time: 1637748869000,
            salePrice: "RM20.80 - RM67.20",
            price: "",
            product_id: 160,
            place: "Melaka",
            title:
              "Inheritor tea black tea new tea Jinjun M传承者茶叶红茶 新茶金骏眉正山小种浓香耐泡养胃罐装礼盒装lrw3f3ycn7Local SellerCOD",
            url:
              "https://my.xiapibuy.com//Inheritor-tea-black-tea-new-tea-Jinjun-M传承者茶叶红茶-新茶金骏眉正山小种浓香耐泡养胃罐装礼盒装lrw3f3ycn7-i.431042679.13203963992?sp_atk=2079661d-1c14-4653-baa2-298042c40eec",
            labels: [],
            soldNum: 2424,
            review: 242,
            star: 3,
          },
          {
            country: "马来西亚",
            tea: "大红袍",
            image:
              "https://cf.shopee.com.my/file/f1b10da91d69981e4146bd824c2e7075_tn",
            sold: "1 sold",
            create_time: 1637748869000,
            salePrice: "RM58.10",
            price: "RM145.45",
            product_id: 74,
            place: "Mainland China",
            title:
              "【大红袍】木桶装大红袍 正宗武夷岩茶 浓香型乌龙茶 300g茶叶 木桶礼盒装  【Dahongpao】 in wooden barrel Dahongpao authentic Wuyi rock tea Luzhou-flavor oolong tea 300g tea wooden barrel gift boxRM5 offCOD",
            url:
              "https://my.xiapibuy.com//【大红袍】木桶装大红袍-正宗武夷岩茶-浓香型乌龙茶-300g茶叶-木桶礼盒装-【Dahongpao】-in-wooden-barrel-Dahongpao-authentic-Wuyi-rock-tea-Luzhou-flavor-oolong-tea-300g-tea-wooden-barrel-gift-box-i.513884826.12050019666?sp_atk=6bbcd7c9-e3b4-4c96-a8e5-c836a541d00b",
            labels: [],
            soldNum: 4489,
            review: 374,
            star: 5,
          },
          {
            country: "马来西亚",
            tea: "茉莉花",
            image:
              "https://cf.shopee.com.my/file/20a5602194fedf81de8f21ef1a5b6d78_tn",
            sold: "561 sold",
            create_time: 1637748869000,
            salePrice: "RM2.95",
            price: "RM5.00",
            product_id: 30,
            place: "Kuala Lumpur",
            title:
              "【SALES????】农夫山泉 茶兀 茶派 (柚子绿茶 / 玫瑰荔枝红茶 / 蜜桃乌龙茶 / 柠檬红茶 / 西柚茉莉花茶) NongFu Spring Fruit Tea Cha Pai500mlShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//【SALES????】农夫山泉-茶兀-茶派-(柚子绿茶-玫瑰荔枝红茶-蜜桃乌龙茶-柠檬红茶-西柚茉莉花茶)-NongFu-Spring-Fruit-Tea-Cha-Pai500ml-i.61764449.13808918658?sp_atk=0c12a257-3d2c-4bf4-8b4e-308cfb59936d",
            labels: [],
            soldNum: 1231,
            review: 76,
            star: 3,
          },
          {
            country: "马来西亚",
            tea: "正山小种",
            image:
              "https://cf.shopee.com.my/file/22d78d2f88bc1d61b24c6298224e5ed2_tn",
            sold: "949 sold",
            create_time: 1637748869000,
            salePrice: "RM0.55",
            price: "RM1.10",
            product_id: 121,
            place: "Penang",
            title:
              "福建红茶正山小种茶叶 6g Fujian Black Tea Zhengshan Small TeaShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//福建红茶正山小种茶叶-6g-Fujian-Black-Tea-Zhengshan-Small-Tea-i.60201032.3338624999?sp_atk=9e9aa90e-1890-478d-9b33-4f557c51468a",
            labels: [],
            soldNum: 2010,
            review: 111,
            star: 4,
          },
          {
            country: "马来西亚",
            tea: "大红袍",
            image:
              "https://cf.shopee.com.my/file/f2ca9597d39b4d0a4e64efa92ba448bd_tn",
            sold: "35.7k sold",
            create_time: 1637748869000,
            salePrice: "RM0.49 - RM0.89",
            price: "",
            product_id: 69,
            place: "Kedah",
            title:
              "【中国茶小袋装】铁观音 大红袍 黑乌龙 普洱 5-7g Chinese TeasShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//【中国茶小袋装】铁观音-大红袍-黑乌龙-普洱-5-7g-Chinese-Teas-i.15549999.9328673007?sp_atk=90fc5670-2d96-45f2-a5aa-dd963f7e89f6",
            labels: [],
            soldNum: 918,
            review: 91,
            star: 3,
          },
          {
            country: "马来西亚",
            tea: "大红袍",
            image:
              "https://cf.shopee.com.my/file/c31ab07142288816e1ce81a5cbef3617_tn",
            sold: "60 sold",
            create_time: 1637748869000,
            salePrice: "RM39.98 - RM176.00",
            price: "",
            product_id: 94,
            place: "Mainland China",
            title:
              "Wuyi Rock Tea Dahongpao Jin Junmei Lapsang Souchong Black Te武夷岩茶大红袍金骏眉正山小种红茶叶木桶散装罐装礼盒装500g礼weixianyuanming.myFree Gift",
            url:
              "https://my.xiapibuy.com//Wuyi-Rock-Tea-Dahongpao-Jin-Junmei-Lapsang-Souchong-Black-Te武夷岩茶大红袍金骏眉正山小种红茶叶木桶散装罐装礼盒装500g礼weixianyuanming.my-i.202931586.8718704089?sp_atk=25c66921-027d-49f0-bc63-1397317aeb40",
            labels: [],
            soldNum: 1081,
            review: 108,
            star: 4,
          },
          {
            country: "马来西亚",
            tea: "茉莉花",
            image:
              "https://cf.shopee.com.my/file/f07f03d8d5e404a423fcb0a7389a82f8_tn",
            sold: "118 sold",
            create_time: 1637748869000,
            salePrice: "RM8.90",
            price: "RM9.50",
            product_id: 10,
            place: "Kuala Lumpur",
            title:
              "????现货????精美铁盒+单独包装 中国茶 大红袍 铁观音 普洱熟茶 黑乌龙 龙井茶 小种红茶 茉莉花茶 高山绿茶 炭焙铁观音 碧螺春 金俊眉 Chinese Tea Da Hong Pao Puer Tie Guan YinShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//????现货????精美铁盒-单独包装-中国茶-大红袍-铁观音-普洱熟茶-黑乌龙-龙井茶-小种红茶-茉莉花茶-高山绿茶-炭焙铁观音-碧螺春-金俊眉-Chinese-Tea-Da-Hong-Pao-Puer-Tie-Guan-Yin-i.128031579.12917419602?sp_atk=03fb6e5d-1708-45a6-868d-906a43cf1640",
            labels: [],
            soldNum: 1175,
            review: 69,
            star: 3,
          },
          {
            country: "马来西亚",
            tea: "茉莉花",
            image:
              "https://cf.shopee.com.my/file/53684d080e50ca5ba7ccb2612f93c6fd_tn",
            sold: "41 sold",
            create_time: 1637748869000,
            salePrice: "RM25.90",
            price: "",
            product_id: 57,
            place: "Perak",
            title:
              "1袋50包 菊花决明子茶 Chrysanthemum Cassia Seed Tea 养生茶 清肝泻火50% offLocal Seller",
            url:
              "https://my.xiapibuy.com//1袋50包-菊花决明子茶-Chrysanthemum-Cassia-Seed-Tea-养生茶-清肝泻火-i.277548324.8854696427?sp_atk=bc389f05-a764-44d8-944c-5fb90ce67b62",
            labels: [],
            soldNum: 1189,
            review: 74,
            star: 3,
          },
          {
            country: "马来西亚",
            tea: "大红袍",
            image:
              "https://cf.shopee.com.my/file/f30bd01cfa39ca1f121e807718144767_tn",
            sold: "3.3k sold",
            create_time: 1637748869000,
            salePrice: "RM1.01",
            price: "RM5.00",
            product_id: 61,
            place: "Negeri Sembilan",
            title:
              "武夷山大红袍 5g 中国茶 Dahongpao Tea 1 pack 5g(26 packs=1box)ShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//武夷山大红袍-5g-中国茶-Dahongpao-Tea-1-pack-5g(26-packs-1box)-i.26435989.4967239930?sp_atk=401cbd99-b1ad-4d93-852c-b3c23ff59a12",
            labels: [],
            soldNum: 4782,
            review: 239,
            star: 4,
          },
          {
            country: "马来西亚",
            tea: "茉莉花",
            image:
              "https://cf.shopee.com.my/file/68906710acf7f0187e967116cc88ace5_tn",
            sold: "17 sold",
            create_time: 1637748869000,
            salePrice: "RM2.59",
            price: "",
            product_id: 3,
            place: "Johor",
            title:
              "农夫山泉 茶兀 茶派 柚子绿茶 玫瑰荔枝红茶 蜜桃乌龙茶 柠檬红茶 西柚茉莉花茶 500ml NongFu Spring Fruit Tea 500mShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//农夫山泉-茶兀-茶派-柚子绿茶-玫瑰荔枝红茶-蜜桃乌龙茶-柠檬红茶-西柚茉莉花茶-500ml-NongFu-Spring-Fruit-Tea-500m-i.277296017.14301040296?sp_atk=f8a4760c-a069-4fcd-a10a-12633ff813d6",
            labels: [],
            soldNum: 4627,
            review: 462,
            star: 5,
          },
          {
            country: "马来西亚",
            tea: "大红袍",
            image:
              "https://cf.shopee.com.my/file/3ef9bfac59254673c55d189839e18f83_tn",
            sold: "",
            create_time: 1637748869000,
            salePrice: "RM28.80",
            price: "RM49.00",
            product_id: 76,
            place: "Selangor",
            title:
              "Fu Jian WuYi  Mountain DaHongPao Tea（a box 30pcs）武夷山岩茶大红袍RM1 offShopMalaysia",
            url:
              "https://my.xiapibuy.com//Fu-Jian-WuYi-Mountain-DaHongPao-Tea（a-box-30pcs）武夷山岩茶大红袍-i.155958055.12647869425?sp_atk=69c771e5-b584-41e8-9813-7c54b8c4d63d",
            labels: [],
            soldNum: 479,
            review: 47,
            star: 3,
          },
          {
            country: "马来西亚",
            tea: "正山小种",
            image:
              "https://cf.shopee.com.my/file/22d78d2f88bc1d61b24c6298224e5ed2_tn",
            sold: "949 sold",
            create_time: 1637748869000,
            salePrice: "RM0.55",
            price: "RM1.10",
            product_id: 128,
            place: "Penang",
            title:
              "福建红茶正山小种茶叶 6g Fujian Black Tea Zhengshan Small TeaShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//福建红茶正山小种茶叶-6g-Fujian-Black-Tea-Zhengshan-Small-Tea-i.60201032.3338624999?sp_atk=06a79976-2e44-496f-bdc5-f81db6cdf361",
            labels: [],
            soldNum: 3649,
            review: 228,
            star: 3,
          },
          {
            country: "马来西亚",
            tea: "茉莉花",
            image:
              "https://cf.shopee.com.my/file/f96736bd94306e525407511b975a6b48_tn",
            sold: "4k sold",
            create_time: 1637748869000,
            salePrice: "RM3.05 - RM3.48",
            price: "",
            product_id: 2,
            place: "Negeri Sembilan",
            title:
              "Ccmc.Flower Tea Bag/Teh Bunga Floral Tea 花茶 herbal 菊花决明子茶桂圆红枣茶胖大海菊花茶五宝茶男人茶罗汉果红豆薏米芡实茶菊苣栀子茶冬瓜荷叶茶冬瓜茶脂流茶玉米须桑叶茶草本三清茶酸梅汤ShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//Ccmc.Flower-Tea-Bag-Teh-Bunga-Floral-Tea-花茶-herbal-菊花决明子茶桂圆红枣茶胖大海菊花茶五宝茶男人茶罗汉果红豆薏米芡实茶菊苣栀子茶冬瓜荷叶茶冬瓜茶脂流茶玉米须桑叶茶草本三清茶酸梅汤-i.51183430.8632561564?sp_atk=66e4e298-6651-4f8b-b9ef-d178dc199446",
            labels: [],
            soldNum: 899,
            review: 81,
            star: 4,
          },
          {
            country: "马来西亚",
            tea: "大红袍",
            image:
              "https://cf.shopee.com.my/file/a1f2d60b23470a3feae3cd3f6622f32f_tn",
            sold: "",
            create_time: 1637748869000,
            salePrice: "RM116.20",
            price: "RM290.69",
            product_id: 118,
            place: "Mainland China",
            title:
              "【大红袍】正宗武夷山 源产地发货 浓香型 乌龙茶 武夷岩茶 铁罐装250g 【Dahongpao】 250g of Luzhou-flavor Oolong Tea and Wuyi Rock Tea Can Be Delivered from the Original Origin of Wuyi Mountain.RM20 offCOD",
            url:
              "https://my.xiapibuy.com//【大红袍】正宗武夷山-源产地发货-浓香型-乌龙茶-武夷岩茶-铁罐装250g-【Dahongpao】-250g-of-Luzhou-flavor-Oolong-Tea-and-Wuyi-Rock-Tea-Can-Be-Delivered-from-the-Original-Origin-of-Wuyi-Mountain.-i.513884826.12631114509?sp_atk=716ba55c-f3c2-4b2b-868b-0f3ffe29af53",
            labels: [],
            soldNum: 3248,
            review: 324,
            star: 4,
          },
          {
            country: "马来西亚",
            tea: "茉莉花",
            image:
              "https://cf.shopee.com.my/file/7f9c5f25c7a38066c877a793973f84cd_tn",
            sold: "1 sold",
            create_time: 1637748869000,
            salePrice: "RM12.10 - RM50.16",
            price: "",
            product_id: 11,
            place: "Melaka",
            title:
              "Jasmine tea 2021 new tea jasmine tea jas茉莉花茶 茶叶 2021新茶茉莉花茶叶茉莉花茶袋装罐装250g500g125glrw3f3ycn7Local SellerCOD",
            url:
              "https://my.xiapibuy.com//Jasmine-tea-2021-new-tea-jasmine-tea-jas茉莉花茶-茶叶-2021新茶茉莉花茶叶茉莉花茶袋装罐装250g500g125glrw3f3ycn7-i.431042679.12229854320?sp_atk=643330f3-d3f0-4813-82e0-ee990ae6db8f",
            labels: [],
            soldNum: 2459,
            review: 153,
            star: 5,
          },
          {
            country: "马来西亚",
            tea: "茉莉花",
            image:
              "https://cf.shopee.com.my/file/9fe8c7d588b99ff8e27239de38af0053_tn",
            sold: "1.4k sold",
            create_time: 1637748869000,
            salePrice: "RM3.00",
            price: "",
            product_id: 39,
            place: "Selangor",
            title:
              "茉莉花茶 | 香片 Jasmine Tea【6 packs x 8g】| 【 Scented tea 花茶 】 Chinese Tea 中国茶叶 Teh Cina 中国茶 茶叶 茶ShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//茉莉花茶-香片-Jasmine-Tea【6-packs-x-8g】-【-Scented-tea-花茶-】-Chinese-Tea-中国茶叶-Teh-Cina-中国茶-茶叶-茶-i.142200712.5700853274?sp_atk=dcb2fa93-c1cf-40f4-9f57-33cdd645cf2f",
            labels: [],
            soldNum: 430,
            review: 33,
            star: 4,
          },
          {
            country: "马来西亚",
            tea: "茉莉花",
            image:
              "https://cf.shopee.com.my/file/8eb853fe863753be17f3c036c04e5fcc_tn",
            sold: "",
            create_time: 1637748869000,
            salePrice: "RM22.68 - RM43.48",
            price: "",
            product_id: 43,
            place: "Mainland China",
            title:
              "Tea bag bag disposable soup coffee bag filter jasmine tea corn fiber triangle tea bag food pole茶包袋一次性煲汤咖啡袋过滤茉莉花茶玉米纤维三角泡茶叶袋食品极zhangli888.my 5.15RM1 offCOD",
            url:
              "https://my.xiapibuy.com//Tea-bag-bag-disposable-soup-coffee-bag-filter-jasmine-tea-corn-fiber-triangle-tea-bag-food-pole茶包袋一次性煲汤咖啡袋过滤茉莉花茶玉米纤维三角泡茶叶袋食品极zhangli888.my-5.15-i.485318768.10467227861?sp_atk=643d6508-454b-4ff0-a7c3-cccb42574e77",
            labels: [],
            soldNum: 3981,
            review: 248,
            star: 3,
          },
          {
            country: "马来西亚",
            tea: "茉莉花",
            image:
              "https://cf.shopee.com.my/file/77355b0c2469c69c75dab75e59f840ab_tn",
            sold: "12 sold",
            create_time: 1637748869000,
            salePrice: "RM23.00",
            price: "",
            product_id: 46,
            place: "Kuala Lumpur",
            title:
              "Sunflower Brand 1032 Jasmine Tea (227g) 向阳花牌茉莉花茶RM0.5 offShopMalaysia",
            url:
              "https://my.xiapibuy.com//Sunflower-Brand-1032-Jasmine-Tea-(227g)-向阳花牌茉莉花茶-i.290454622.9209712992?sp_atk=cece19d8-eab2-40a0-8bed-58ad3be36f5e",
            labels: [],
            soldNum: 43,
            review: 2,
            star: 3,
          },
          {
            country: "马来西亚",
            tea: "大红袍",
            image:
              "https://cf.shopee.com.my/file/7231b6ab83defc316bbf5d64d6661e7f_tn",
            sold: "2.6k sold",
            create_time: 1637748869000,
            salePrice: "RM50.00",
            price: "RM75.00",
            product_id: 72,
            place: "Selangor",
            title:
              "中国茶叶 Chinese tea Teh 【100g x 3】 绿茶 大红袍 普洱 铁观音 黄金桂 水仙 乌龙茶 茉莉花茶 红茶 Puer Tea Green tea Black tea Jasmine Tea Tie guan yinShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//中国茶叶-Chinese-tea-Teh-【100g-x-3】-绿茶-大红袍-普洱-铁观音-黄金桂-水仙-乌龙茶-茉莉花茶-红茶-Puer-Tea-Green-tea-Black-tea-Jasmine-Tea-Tie-guan-yin-i.142200712.7006322272?sp_atk=c5943745-f7d9-41c8-9469-a0d4e279dfce",
            labels: [],
            soldNum: 1481,
            review: 105,
            star: 3,
          },
          {
            country: "马来西亚",
            tea: "正山小种",
            image:
              "https://cf.shopee.com.my/file/667f60cbbf9107000d99fc687bf04e50_tn",
            sold: "",
            create_time: 1637748869000,
            salePrice: "RM94.80 - RM117.45",
            price: "",
            product_id: 156,
            place: "Selangor",
            title:
              "Tea 过节送礼 武夷山大红袍高档礼盒 正山小种金骏眉茶叶特级红茶500g 0923Local SellerCOD",
            url:
              "https://my.xiapibuy.com//Tea-过节送礼-武夷山大红袍高档礼盒-正山小种金骏眉茶叶特级红茶500g-0923-i.426356574.13914512147?sp_atk=6591c703-517f-4b5f-8066-d6dde5446a9b",
            labels: [],
            soldNum: 4191,
            review: 232,
            star: 4,
          },
          {
            country: "马来西亚",
            tea: "正山小种",
            image:
              "https://cf.shopee.com.my/file/547b28a3dd8a4f482af72d07575c6c17_tn",
            sold: "86 sold",
            create_time: 1637748869000,
            salePrice: "RM1.30",
            price: "",
            product_id: 158,
            place: "Perak",
            title: "正山小种 5g 红茶 Red Tea 1packShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//正山小种-5g-红茶-Red-Tea-1pack-i.32606391.6264410670?sp_atk=2d278b90-8d42-4d12-90b2-d618e1fe1f9b",
            labels: [],
            soldNum: 2093,
            review: 104,
            star: 5,
          },
          {
            country: "马来西亚",
            tea: "茉莉花",
            image:
              "https://cf.shopee.com.my/file/ea87a6fd19552a8cd2b0f683af7aab7f_tn",
            sold: "31 sold",
            create_time: 1637748869000,
            salePrice: "RM5.20",
            price: "",
            product_id: 50,
            place: "Selangor",
            title:
              "【花茶 Flower Tea】Loherbs 茉莉花茶 Dried Jasmine Flower Tea 50Gram / Bunga Jasmine Kering/ Bunga Melati KeringShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//【花茶-Flower-Tea】Loherbs-茉莉花茶-Dried-Jasmine-Flower-Tea-50Gram-Bunga-Jasmine-Kering-Bunga-Melati-Kering-i.16878056.13702335089?sp_atk=a05c72c8-cf34-401c-bb81-3ebb876fe8eb",
            labels: [],
            soldNum: 3340,
            review: 185,
            star: 3,
          },
          {
            country: "马来西亚",
            tea: "正山小种",
            image:
              "https://cf.shopee.com.my/file/79794e1496508c29c51788d335d02943_tn",
            sold: "",
            create_time: 1637748869000,
            salePrice: "RM32.00 - RM110.00",
            price: "",
            product_id: 146,
            place: "Mainland China",
            title:
              "Xincha Zhengshan seed bulk red tea Luzhou flavor seed bagged 500g manufacturer w�新茶正山小种散装红茶叶浓香型小种袋装500克厂家批发口粮茶便宜jiumei10.my21.10.31RM5 off",
            url:
              "https://my.xiapibuy.com//Xincha-Zhengshan-seed-bulk-red-tea-Luzhou-flavor-seed-bagged-500g-manufacturer-w�新茶正山小种散装红茶叶浓香型小种袋装500克厂家批发口粮茶便宜jiumei10.my21.10.31-i.427603284.13940465849?sp_atk=7fe4b7be-a528-41d7-ae60-d03639f3b748",
            labels: [],
            soldNum: 2494,
            review: 131,
            star: 3,
          },
          {
            country: "马来西亚",
            tea: "茉莉花",
            image:
              "https://cf.shopee.com.my/file/9a99b82d5242a193f19b8f8439a0cd8c_tn",
            sold: "",
            create_time: 1637748869000,
            salePrice: "RM0.75 - RM4.50",
            price: "",
            product_id: 38,
            place: "Selangor",
            title:
              "Flower Tea mix & match 花茶搭配 [Rose玫瑰 , Jasmine茉莉, Roselle洛神花 , Lavender薰衣草 , Chamomile洋甘菊 , Lily百合, Apple Flower苹果花 ]ShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//Flower-Tea-mix-match-花茶搭配-Rose玫瑰-Jasmine茉莉-Roselle洛神花-Lavender薰衣草-Chamomile洋甘菊-Lily百合-Apple-Flower苹果花--i.316348212.13311467052?sp_atk=6c6b0c1f-bfa3-47db-8ef9-44501186be51",
            labels: [],
            soldNum: 4054,
            review: 368,
            star: 3,
          },
          {
            country: "马来西亚",
            tea: "大红袍",
            image:
              "https://cf.shopee.com.my/file/dc7caba94f90ce43f28ebe2bc3beb05d_tn",
            sold: "1.7k sold",
            create_time: 1637748869000,
            salePrice: "RM16.79 - RM19.03",
            price: "",
            product_id: 100,
            place: "Selangor",
            title:
              "茶叶 铁观音 大红袍 金骏眉 碧螺春 普洱 高山绿茶 毛尖 Chinese tea Teh Cina White tea puer Pu Er Tie guan yin Teh ChinaShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//茶叶-铁观音-大红袍-金骏眉-碧螺春-普洱-高山绿茶-毛尖-Chinese-tea-Teh-Cina-White-tea-puer-Pu-Er-Tie-guan-yin-Teh-China-i.10462357.3874062737?sp_atk=8a32cf44-cc61-4668-883b-fbb4c9f36f3f",
            labels: [],
            soldNum: 2566,
            review: 213,
            star: 4,
          },
          {
            country: "马来西亚",
            tea: "大红袍",
            image:
              "https://cf.shopee.com.my/file/c6ac6bd7f3863efac41ab32e1e9b4882_tn",
            sold: "",
            create_time: 1637748869000,
            salePrice: "RM15.84 - RM47.36",
            price: "",
            product_id: 79,
            place: "Melaka",
            title:
              "Ye Song Tea Black Tea Lapsang Souchong J叶颂茶叶 红茶正山小种金骏眉 大红袍 铁观音多款任选 礼盒装新茶lrw3f3ycn7Local SellerCOD",
            url:
              "https://my.xiapibuy.com//Ye-Song-Tea-Black-Tea-Lapsang-Souchong-J叶颂茶叶-红茶正山小种金骏眉-大红袍-铁观音多款任选-礼盒装新茶lrw3f3ycn7-i.431042679.13004573231?sp_atk=59edca51-6229-4fb9-a3e9-65152ad315c6",
            labels: [],
            soldNum: 1996,
            review: 166,
            star: 5,
          },
          {
            country: "马来西亚",
            tea: "茉莉花",
            image:
              "https://cf.shopee.com.my/file/7cb997935f7d443626569a026737f982_tn",
            sold: "32 sold",
            create_time: 1637748869000,
            salePrice: "RM5.90",
            price: "",
            product_id: 27,
            place: "Perak",
            title:
              "{RM 5.9 / 50g} Jasmine tea  flower tea 浓香型茉莉花茶浓香小白豪 花茶ShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//-RM-5.9-50g-Jasmine-tea-flower-tea-浓香型茉莉花茶浓香小白豪-花茶-i.175903848.3537059934?sp_atk=ea12bb88-f1bc-4b0e-a851-bf3f1faece1f",
            labels: [],
            soldNum: 1929,
            review: 175,
            star: 4,
          },
          {
            country: "马来西亚",
            tea: "茉莉花",
            image:
              "https://cf.shopee.com.my/file/c83ecef3e9b08b2c1345a97e3d42ef81_tn",
            sold: "35 sold",
            create_time: 1637748869000,
            salePrice: "RM7.99",
            price: "",
            product_id: 52,
            place: "Perak",
            title:
              "渝达 茉莉绿茶 Jasmine Green Tea 排毒养颜 花茶50% offLocal Seller",
            url:
              "https://my.xiapibuy.com//渝达-茉莉绿茶-Jasmine-Green-Tea-排毒养颜-花茶-i.277548324.5386869197?sp_atk=cada7082-e1f9-437e-809a-06e7482dfd69",
            labels: [],
            soldNum: 3165,
            review: 166,
            star: 3,
          },
          {
            country: "马来西亚",
            tea: "茉莉花",
            image:
              "https://cf.shopee.com.my/file/8fdd21a0af3044e9e54fc2b8cc47e831_tn",
            sold: "65 sold",
            create_time: 1637748869000,
            salePrice: "RM13.50",
            price: "",
            product_id: 59,
            place: "Perak",
            title:
              "菊花决明子茶 Chrysanthemum Cassia Seed Tea (30s) 熬夜恢复茶 养肝茶Local Seller",
            url:
              "https://my.xiapibuy.com//菊花决明子茶-Chrysanthemum-Cassia-Seed-Tea-(30s)-熬夜恢复茶-养肝茶-i.277548324.3039552521?sp_atk=2cf589f4-33bb-4ce7-bcea-938147b9858e",
            labels: [],
            soldNum: 291,
            review: 22,
            star: 4,
          },
          {
            country: "马来西亚",
            tea: "茉莉花",
            image:
              "https://cf.shopee.com.my/file/3509cce1ebb8530c379ca17640cf2147_tn",
            sold: "68k sold",
            create_time: 1637748869000,
            salePrice: "RM0.27 - RM0.95",
            price: "",
            product_id: 56,
            place: "Perak",
            title:
              "【COH】花茶 花茶包 Flower tea | Teh Bunga【壹间草药】无糖 No sugar Sugar free Tea 茶包 花茶 养生茶 Beauty 排毒 养生花茶 玫瑰 Rose Jasmine Tea bagShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//【COH】花茶-花茶包-Flower-tea-Teh-Bunga【壹间草药】无糖-No-sugar-Sugar-free-Tea-茶包-花茶-养生茶-Beauty-排毒-养生花茶-玫瑰-Rose-Jasmine-Tea-bag-i.26353660.10807019469?sp_atk=c261e8db-e41c-4be5-af4a-60fc99a7bf25",
            labels: [],
            soldNum: 3677,
            review: 183,
            star: 5,
          },
          {
            country: "马来西亚",
            tea: "大红袍",
            image:
              "https://cf.shopee.com.my/file/a576ac0fb90a806531be75a8c01066b2_tn",
            sold: "604 sold",
            create_time: 1637748869000,
            salePrice: "RM21.08",
            price: "RM26.34",
            product_id: 68,
            place: "Kuala Lumpur",
            title:
              "大红袍茶叶 罐装散装250g （1罐） Da Hong Pao TeaShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//大红袍茶叶-罐装散装250g-（1罐）-Da-Hong-Pao-Tea-i.266929667.3355939218?sp_atk=738fb78b-081a-4087-a56f-c2c9c2f05987",
            labels: [],
            soldNum: 2084,
            review: 138,
            star: 5,
          },
          {
            country: "马来西亚",
            tea: "大红袍",
            image:
              "https://cf.shopee.com.my/file/371c0fe6f8d9acd8622bbaf375511a89_tn",
            sold: "264 sold",
            create_time: 1637748869000,
            salePrice: "RM61.88 - RM302.64",
            price: "",
            product_id: 73,
            place: "Johor",
            title:
              "【大红袍】武夷山正岩顶级大红袍茶 50克罐装 礼盒装 精选大红袍 高山乌龙茶 精美罐装 送礼佳品 绝对耐泡 Premium Da Hong Pao Wuyi Rock Tea 50gShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//【大红袍】武夷山正岩顶级大红袍茶-50克罐装-礼盒装-精选大红袍-高山乌龙茶-精美罐装-送礼佳品-绝对耐泡-Premium-Da-Hong-Pao-Wuyi-Rock-Tea-50g-i.305390642.3552510858?sp_atk=50337424-e197-4d50-b088-5a52fbe7dcc4",
            labels: [],
            soldNum: 4425,
            review: 276,
            star: 3,
          },
          {
            country: "马来西亚",
            tea: "茉莉花",
            image:
              "https://cf.shopee.com.my/file/d04aba69aa6942a0e4bac29aeb80f359_tn",
            sold: "3 sold",
            create_time: 1637748869000,
            salePrice: "RM12.58",
            price: "RM14.80",
            product_id: 41,
            place: "Selangor",
            title:
              "100g Chinese Tea tie guan yin biluo chun Green Tea Jasmine Tea 铁观音 高山绿茶 碧罗春 茉莉花茶 100 gramShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//100g-Chinese-Tea-tie-guan-yin-biluo-chun-Green-Tea-Jasmine-Tea-铁观音-高山绿茶-碧罗春-茉莉花茶-100-gram-i.10462357.13204699705?sp_atk=c886bee1-38ef-43ea-acfd-f4f155f6106a",
            labels: [],
            soldNum: 1643,
            review: 164,
            star: 4,
          },
          {
            country: "马来西亚",
            tea: "大红袍",
            image:
              "https://cf.shopee.com.my/file/f73c25a67d0de2457c79252fb3d09b4a_tn",
            sold: "917 sold",
            create_time: 1637748869000,
            salePrice: "RM0.99 - RM1.20",
            price: "",
            product_id: 104,
            place: "Selangor",
            title:
              "散装茶叶小包装 铁观音 大红袍 金骏眉 高山绿茶 碧螺春 普洱熟茶 龙井 5g Tie Guan Yin Da Hong Pao Puer teh Jasmine teaShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//散装茶叶小包装-铁观音-大红袍-金骏眉-高山绿茶-碧螺春-普洱熟茶-龙井-5g-Tie-Guan-Yin-Da-Hong-Pao-Puer-teh-Jasmine-tea-i.10462357.9339083705?sp_atk=c2dfdf2d-68c6-4f11-bda5-57c42d57c7c9",
            labels: [],
            soldNum: 23,
            review: 1,
            star: 5,
          },
          {
            country: "马来西亚",
            tea: "正山小种",
            image:
              "https://cf.shopee.com.my/file/79429c724821de56670160ef851a3865_tn",
            sold: "",
            create_time: 1637748869000,
            salePrice: "RM13.16 - RM34.40",
            price: "",
            product_id: 149,
            place: "Melaka",
            title:
              "Pot four cups of tea black tea Jinjunmei壶四杯茶叶红茶金骏眉正山小种浓香型新茶礼盒小包装250glrw3f3ycn7Local SellerCOD",
            url:
              "https://my.xiapibuy.com//Pot-four-cups-of-tea-black-tea-Jinjunmei壶四杯茶叶红茶金骏眉正山小种浓香型新茶礼盒小包装250glrw3f3ycn7-i.431042679.13529834386?sp_atk=f30e8bb5-8b03-4ebf-8783-978921301060",
            labels: [],
            soldNum: 2269,
            review: 151,
            star: 5,
          },
          {
            country: "马来西亚",
            tea: "大红袍",
            image:
              "https://cf.shopee.com.my/file/344fc23ca43122f2c311d8d1d816371f_tn",
            sold: "2 sold",
            create_time: 1637748869000,
            salePrice: "RM33.50 - RM60.20",
            price: "",
            product_id: 110,
            place: "Mainland China",
            title:
              "【 武夷山大红袍】正岩岩茶 浓香型肉桂 水仙奇兰 盒装250g 【Wuyishan Dahongpao】 Zhengyan Rock Tea Luzhou-flavor Cinnamon Narcissus Chilan Boxed 250g.RM2 offCOD",
            url:
              "https://my.xiapibuy.com//【-武夷山大红袍】正岩岩茶-浓香型肉桂-水仙奇兰-盒装250g-【Wuyishan-Dahongpao】-Zhengyan-Rock-Tea-Luzhou-flavor-Cinnamon-Narcissus-Chilan-Boxed-250g.-i.513884826.11859947689?sp_atk=3793280f-dda8-4770-acbe-a4a56ae1db67",
            labels: [],
            soldNum: 2978,
            review: 297,
            star: 4,
          },
          {
            country: "马来西亚",
            tea: "茉莉花",
            image:
              "https://cf.shopee.com.my/file/1af17848060566b14fda63ab1c149f41_tn",
            sold: "21 sold",
            create_time: 1637748869000,
            salePrice: "RM4.70",
            price: "",
            product_id: 40,
            place: "Kuala Lumpur",
            title:
              "Sprouting Brand JT001 Jasmine Tea Bags (40g) 新芽牌茉莉花茶袋泡茶ShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//Sprouting-Brand-JT001-Jasmine-Tea-Bags-(40g)-新芽牌茉莉花茶袋泡茶-i.290454622.8062677188?sp_atk=b45e6137-734b-4b97-9bf7-58f04a93198a",
            labels: [],
            soldNum: 4562,
            review: 325,
            star: 5,
          },
          {
            country: "马来西亚",
            tea: "大红袍",
            image:
              "https://cf.shopee.com.my/file/611616c5c3c382d2f4359d299a8b1384_tn",
            sold: "306 sold",
            create_time: 1637748869000,
            salePrice: "RM1.50",
            price: "RM1.55",
            product_id: 111,
            place: "Penang",
            title:
              "2020新茶 武夷大红袍茶叶 肉桂岩茶 Dahongpao TeaShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//2020新茶-武夷大红袍茶叶-肉桂岩茶-Dahongpao-Tea-i.60201032.5284150983?sp_atk=5c21fa02-cf34-4b7f-97cd-e4f30e70a8f6",
            labels: [],
            soldNum: 2653,
            review: 132,
            star: 4,
          },
          {
            country: "马来西亚",
            tea: "正山小种",
            image:
              "https://cf.shopee.com.my/file/6678fb9d28740629583b2f1f09225754_tn",
            sold: "2 sold",
            create_time: 1637748869000,
            salePrice: "RM28.00 - RM58.50",
            price: "",
            product_id: 180,
            place: "Mainland China",
            title:
              "金骏眉正山小种250g/500g茶叶红茶礼盒装浓香型Jinjunmei Zhengshan Race 250g/500g Tea Black Tea Gift Box Luzhou-flavorRM2 offCOD",
            url:
              "https://my.xiapibuy.com//金骏眉正山小种250g-500g茶叶红茶礼盒装浓香型Jinjunmei-Zhengshan-Race-250g-500g-Tea-Black-Tea-Gift-Box-Luzhou-flavor-i.513884826.11830571124?sp_atk=633c1c54-ab63-4e0f-a0fa-8844263d2ec2",
            labels: [],
            soldNum: 3005,
            review: 214,
            star: 5,
          },
          {
            country: "马来西亚",
            tea: "正山小种",
            image:
              "https://cf.shopee.com.my/file/1e24be0b8b56ad6338ab2e04be5473b3_tn",
            sold: "6 sold",
            create_time: 1637748869000,
            salePrice: "RM9.90",
            price: "",
            product_id: 169,
            place: "Johor",
            title:
              "[Mk] Chinese Tea 茶叶 中国茶 铁观音 大红袍 黑乌龙茶 普洱熟茶 正山小种 龙井 皇菊 茉莉花茶ShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//-Mk-Chinese-Tea-茶叶-中国茶-铁观音-大红袍-黑乌龙茶-普洱熟茶-正山小种-龙井-皇菊-茉莉花茶-i.67430736.10952763072?sp_atk=04977abc-d950-4c2b-9571-2ed75da2c046",
            labels: [],
            soldNum: 4068,
            review: 203,
            star: 4,
          },
          {
            country: "马来西亚",
            tea: "正山小种",
            image:
              "https://cf.shopee.com.my/file/7eded9be01cba401f343d117d525129e_tn",
            sold: "",
            create_time: 1637748869000,
            salePrice: "RM38.00 - RM74.10",
            price: "",
            product_id: 145,
            place: "Melaka",
            title:
              "Tea black tea Jinjunmei Zhengshan small茶叶红茶 金骏眉正山小种茶叶250g/500g 罐装礼盒装茶叶lrw3f3ycn7Local SellerCOD",
            url:
              "https://my.xiapibuy.com//Tea-black-tea-Jinjunmei-Zhengshan-small茶叶红茶-金骏眉正山小种茶叶250g-500g-罐装礼盒装茶叶lrw3f3ycn7-i.431042679.12929854814?sp_atk=79cbc07b-e505-4860-99a1-0924f46056b8",
            labels: [],
            soldNum: 4543,
            review: 227,
            star: 3,
          },
          {
            country: "马来西亚",
            tea: "正山小种",
            image:
              "https://cf.shopee.com.my/file/342c60622b1629534713a7b4581a4848_tn",
            sold: "154 sold",
            create_time: 1637748869000,
            salePrice: "RM15.75",
            price: "RM22.50",
            product_id: 129,
            place: "Kuala Lumpur",
            title:
              "武夷红茶署香味正山小种独立小袋装礼盒装福建茶叶 125g (25s) Zheng Shan Xiao Zhong Black Tea 125gShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//武夷红茶署香味正山小种独立小袋装礼盒装福建茶叶-125g-(25s)-Zheng-Shan-Xiao-Zhong-Black-Tea-125g-i.266929667.7560137504?sp_atk=af57c851-7d6d-4ae5-8114-366738a501a9",
            labels: [],
            soldNum: 846,
            review: 60,
            star: 5,
          },
          {
            country: "马来西亚",
            tea: "茉莉花",
            image:
              "https://cf.shopee.com.my/file/d9f5f1374ad3dc79a513394c41f64570_tn",
            sold: "47 sold",
            create_time: 1637748869000,
            salePrice: "RM10.50",
            price: "RM10.90",
            product_id: 4,
            place: "Penang",
            title:
              "Jasmine Tea Flower Tea 100g 浓香型茉莉花茶浓香小白豪 花茶RM1 offShopMalaysia",
            url:
              "https://my.xiapibuy.com//Jasmine-Tea-Flower-Tea-100g-浓香型茉莉花茶浓香小白豪-花茶-i.60201032.8749449249?sp_atk=cdd61eac-1ddd-418a-a280-c1179e00e3bf",
            labels: [],
            soldNum: 3806,
            review: 211,
            star: 4,
          },
          {
            country: "马来西亚",
            tea: "正山小种",
            image:
              "https://cf.shopee.com.my/file/cfb45424f15a59c6f38a5baa7f87a82a_tn",
            sold: "7 sold",
            create_time: 1637748869000,
            salePrice: "RM27.50 - RM53.10",
            price: "",
            product_id: 122,
            place: "Mainland China",
            title:
              "金骏眉正山小种250g/500g茶叶红茶Jinjunmei Zhengshan Race 250g/500g Tea Black TeaRM2 offCOD",
            url:
              "https://my.xiapibuy.com//金骏眉正山小种250g-500g茶叶红茶Jinjunmei-Zhengshan-Race-250g-500g-Tea-Black-Tea-i.513884826.11930571021?sp_atk=aced34d9-206e-4ee3-9f5f-d2584a16b892",
            labels: [],
            soldNum: 602,
            review: 46,
            star: 5,
          },
          {
            country: "马来西亚",
            tea: "茉莉花",
            image:
              "https://cf.shopee.com.my/file/d03aedce405b4801c268768f7aa9246d_tn",
            sold: "50 sold",
            create_time: 1637748869000,
            salePrice: "RM0.58",
            price: "",
            product_id: 13,
            place: "Melaka",
            title:
              "茶叶 小袋 散装包 普洱茶 碧螺春 毛尖茶 黄金桂 铁观音 绿茶 正山小种 金丝皇菊 茉莉花茶 黑乌龙茶 大红袍 龙井 炭焙铁观音 金骏眉 中国茶叶 #浓香 #现货 #chinese tea pack #ShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//茶叶-小袋-散装包-普洱茶-碧螺春-毛尖茶-黄金桂-铁观音-绿茶-正山小种-金丝皇菊-茉莉花茶-黑乌龙茶-大红袍-龙井-炭焙铁观音-金骏眉-中国茶叶-浓香-现货-chinese-tea-pack--i.396483765.12247654293?sp_atk=31a9ab92-4e73-499b-a641-bca3f9e85bd0",
            labels: [],
            soldNum: 1722,
            review: 114,
            star: 5,
          },
          {
            country: "马来西亚",
            tea: "茉莉花",
            image:
              "https://cf.shopee.com.my/file/5e98a51bba3a920213f6b04c5f323e47_tn",
            sold: "2.3k sold",
            create_time: 1637748869000,
            salePrice: "RM3.63",
            price: "RM5.00",
            product_id: 37,
            place: "Kuala Lumpur",
            title:
              "FYZ Herbs Jasmine Flower Tea 30g [Value Pack] 茉莉花茶袋装 30gShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//FYZ-Herbs-Jasmine-Flower-Tea-30g-Value-Pack-茉莉花茶袋装-30g-i.33209905.868838231?sp_atk=22a45ef0-a806-45b1-90c1-4503891fa5dc",
            labels: [],
            soldNum: 3143,
            review: 184,
            star: 5,
          },
          {
            country: "马来西亚",
            tea: "茉莉花",
            image:
              "https://cf.shopee.com.my/file/95bd08e6d47b1408fd7164594825dc69_tn",
            sold: "5 sold",
            create_time: 1637748869000,
            salePrice: "RM16.80",
            price: "",
            product_id: 19,
            place: "Negeri Sembilan",
            title:
              "茉莉花茶(香片）100g 盒装+礼袋 Jasmine Tea 100g + Free box + Paper bag Chinese Tea 中国茶叶(花茶)  (Scented tea) Teh Cina24% offShopMalaysia",
            url:
              "https://my.xiapibuy.com//茉莉花茶(香片）100g-盒装-礼袋-Jasmine-Tea-100g-Free-box-Paper-bag-Chinese-Tea-中国茶叶(花茶)-(Scented-tea)-Teh-Cina-i.544698837.12338050682?sp_atk=74c388c1-1421-45a5-8ebd-b4c6c8c24cf4",
            labels: [],
            soldNum: 3440,
            review: 191,
            star: 3,
          },
          {
            country: "马来西亚",
            tea: "茉莉花",
            image:
              "https://cf.shopee.com.my/file/161d31e7028f7d5a91ff9e9035d96fa8_tn",
            sold: "6 sold",
            create_time: 1637748869000,
            salePrice: "RM6.00",
            price: "",
            product_id: 34,
            place: "Selangor",
            title:
              "Jasmine Tea (茉莉花茶）50G-RM6.00 (FUNCTION ????????) flowers TeaLocal SellerCOD",
            url:
              "https://my.xiapibuy.com//Jasmine-Tea-(茉莉花茶）50G-RM6.00-(FUNCTION-????????)-flowers-Tea-i.139760977.2287225897?sp_atk=4e27779f-3662-4fe5-a9d1-16cdbbb645bb",
            labels: [],
            soldNum: 4467,
            review: 406,
            star: 3,
          },
          {
            country: "马来西亚",
            tea: "茉莉花",
            image:
              "https://cf.shopee.com.my/file/e11ab7908094ed78b6662115e79c3f01_tn",
            sold: "",
            create_time: 1637748869000,
            salePrice: "RM6.90",
            price: "",
            product_id: 32,
            place: "Kuala Lumpur",
            title:
              "Nongfu Spring Oriental Leaf Sugar Free Drink Jasmine Tea - 500ml 农夫山泉 东方树叶 无糖饮料 茉莉花茶 - 500mlShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//Nongfu-Spring-Oriental-Leaf-Sugar-Free-Drink-Jasmine-Tea-500ml-农夫山泉-东方树叶-无糖饮料-茉莉花茶-500ml-i.98811036.10544993438?sp_atk=236272c9-f579-4ab8-968a-04504d3f669e",
            labels: [],
            soldNum: 3509,
            review: 250,
            star: 4,
          },
          {
            country: "马来西亚",
            tea: "大红袍",
            image:
              "https://cf.shopee.com.my/file/103271f05a7b2f77fc9b6bbb3287523b_tn",
            sold: "1.9k sold",
            create_time: 1637748869000,
            salePrice: "RM1.65",
            price: "RM2.80",
            product_id: 106,
            place: "Penang",
            title:
              "武夷高山大红袍 福建乌龙茶 浓香肉桂 Dahongpao Tea [ High Quality ]ShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//武夷高山大红袍-福建乌龙茶-浓香肉桂-Dahongpao-Tea-High-Quality--i.60201032.4731718517?sp_atk=039b9c8e-5d26-4041-bd92-d1a067a8624a",
            labels: [],
            soldNum: 1748,
            review: 109,
            star: 4,
          },
          {
            country: "马来西亚",
            tea: "茉莉花",
            image:
              "https://cf.shopee.com.my/file/c791a715eb0d7023107b798ed4c4761e_tn",
            sold: "16 sold",
            create_time: 1637748869000,
            salePrice: "RM2.30",
            price: "",
            product_id: 45,
            place: "Kuala Lumpur",
            title:
              "Lipton Fruit Tea 立顿维C 冷泡果茶 速溶果汁茶粉固体饮料 白桃乌龙茶味 Peach Oolong Tea 西柚茉莉花茶 Grapefruit Jasmine Tea 半桔半柠红茶 umquat Lemon Black TeShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//Lipton-Fruit-Tea-立顿维C-冷泡果茶-速溶果汁茶粉固体饮料-白桃乌龙茶味-Peach-Oolong-Tea-西柚茉莉花茶-Grapefruit-Jasmine-Tea-半桔半柠红茶-umquat-Lemon-Black-Te-i.456306598.9594816560?sp_atk=9f173894-07d6-4b24-8e33-fc9f1800a1dd",
            labels: [],
            soldNum: 2442,
            review: 187,
            star: 5,
          },
          {
            country: "马来西亚",
            tea: "大红袍",
            image:
              "https://cf.shopee.com.my/file/5f8439936804e7040b6b6963a62d4185_tn",
            sold: "4.9k sold",
            create_time: 1637748869000,
            salePrice: "RM0.45",
            price: "RM2.00",
            product_id: 63,
            place: "Kuala Lumpur",
            title:
              "{READY STOCK}{中国茶小袋装} 大红袍 铁观音 金骏眉 黑乌龙 普洱茶 6-8g Individual Pack Chinese Tea Tie Guan Yin Da Hong Pao Jasmine Tea Teh CinaShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//-READY-STOCK-中国茶小袋装-大红袍-铁观音-金骏眉-黑乌龙-普洱茶-6-8g-Individual-Pack-Chinese-Tea-Tie-Guan-Yin-Da-Hong-Pao-Jasmine-Tea-Teh-Cina-i.421424331.6297246712?sp_atk=efa98aab-28ba-46d5-af54-04b320e97c8c",
            labels: [],
            soldNum: 889,
            review: 74,
            star: 4,
          },
          {
            country: "马来西亚",
            tea: "正山小种",
            image:
              "https://cf.shopee.com.my/file/ced977d406fc5ee2d7ac10b501a45c37_tn",
            sold: "",
            create_time: 1637748869000,
            salePrice: "RM33.50 - RM115.50",
            price: "",
            product_id: 177,
            place: "Mainland China",
            title:
              "【红茶】特级正山小种茶叶 正宗武夷山新茶 浓香型养胃红茶 小包袋装PC盒  【Black Tea】 Super Zhengshan Race Tea Authentic Wuyishan New Tea Luzhou-flavor Stomach-nourishing Black Tea Packed PC Box.RM2 offCOD",
            url:
              "https://my.xiapibuy.com//【红茶】特级正山小种茶叶-正宗武夷山新茶-浓香型养胃红茶-小包袋装PC盒-【Black-Tea】-Super-Zhengshan-Race-Tea-Authentic-Wuyishan-New-Tea-Luzhou-flavor-Stomach-nourishing-Black-Tea-Packed-PC-Box.-i.513884826.12542545029?sp_atk=d355eae4-fbd2-4d55-ac3c-22074ce895ef",
            labels: [],
            soldNum: 2931,
            review: 293,
            star: 5,
          },
          {
            country: "马来西亚",
            tea: "茉莉花",
            image:
              "https://cf.shopee.com.my/file/4a50fd5845ac45d96d38d7fa675a1b36_tn",
            sold: "76 sold",
            create_time: 1637748869000,
            salePrice: "RM3.31 - RM7.56",
            price: "",
            product_id: 49,
            place: "Selangor",
            title:
              "[High Quality] Natural Dried Jasmine Buds Flower Herbal Tea 茉莉散装花茶ShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//-High-Quality-Natural-Dried-Jasmine-Buds-Flower-Herbal-Tea-茉莉散装花茶-i.80434172.3666492158?sp_atk=489256d4-aeb4-4331-ab71-4c96aa1a8141",
            labels: [],
            soldNum: 2555,
            review: 127,
            star: 3,
          },
          {
            country: "马来西亚",
            tea: "茉莉花",
            image:
              "https://cf.shopee.com.my/file/42da57d47953b797d878a544b1987613_tn",
            sold: "753 sold",
            create_time: 1637748869000,
            salePrice: "RM2.76",
            price: "RM3.60",
            product_id: 22,
            place: "Johor",
            title:
              "现货农夫山泉茶兀果茶系列/茶派/柚子绿茶/玫瑰荔枝红茶/蜜桃乌龙茶/柠檬红茶/西柚茉莉花茶 Nongfu Spring Cha Pai Cha Pie 茶π 茶派 Fruit Tea 500MLLocal SellerCOD",
            url:
              "https://my.xiapibuy.com//现货农夫山泉茶兀果茶系列-茶派-柚子绿茶-玫瑰荔枝红茶-蜜桃乌龙茶-柠檬红茶-西柚茉莉花茶-Nongfu-Spring-Cha-Pai-Cha-Pie-茶π-茶派-Fruit-Tea-500ML-i.530265655.13637249041?sp_atk=3a17af28-bf34-4d7a-9a6f-10f2261ded04",
            labels: [],
            soldNum: 87,
            review: 6,
            star: 4,
          },
          {
            country: "马来西亚",
            tea: "正山小种",
            image:
              "https://cf.shopee.com.my/file/6678fb9d28740629583b2f1f09225754_tn",
            sold: "2 sold",
            create_time: 1637748869000,
            salePrice: "RM28.00 - RM58.50",
            price: "",
            product_id: 133,
            place: "Mainland China",
            title:
              "金骏眉正山小种250g/500g茶叶红茶礼盒装浓香型Jinjunmei Zhengshan Race 250g/500g Tea Black Tea Gift Box Luzhou-flavorRM2 offCOD",
            url:
              "https://my.xiapibuy.com//金骏眉正山小种250g-500g茶叶红茶礼盒装浓香型Jinjunmei-Zhengshan-Race-250g-500g-Tea-Black-Tea-Gift-Box-Luzhou-flavor-i.513884826.11830571124?sp_atk=ba28e260-19cf-4cd2-9e5a-30141bbd5b2d",
            labels: [],
            soldNum: 2844,
            review: 203,
            star: 5,
          },
          {
            country: "马来西亚",
            tea: "茉莉花",
            image:
              "https://cf.shopee.com.my/file/e0ebe2a6973fe85a40f7ff30e6936f80_tn",
            sold: "198.6k sold",
            create_time: 1637748869000,
            salePrice: "RM2.85",
            price: "RM2.90",
            product_id: 7,
            place: "Selangor",
            title:
              "农夫山泉茶兀果茶 系列 Nongfu Spring Cha Pai Fruit Tea 250ml/500ml 茶派 蜜桃乌龙茶/柚子绿茶/柠檬红茶/西柚茉莉花茶Local SellerCOD",
            url:
              "https://my.xiapibuy.com//农夫山泉茶兀果茶-系列-Nongfu-Spring-Cha-Pai-Fruit-Tea-250ml-500ml-茶派-蜜桃乌龙茶-柚子绿茶-柠檬红茶-西柚茉莉花茶-i.323100044.6167004355?sp_atk=5ca05917-b716-4aa7-85fe-35880147e503",
            labels: [],
            soldNum: 4526,
            review: 377,
            star: 5,
          },
          {
            country: "马来西亚",
            tea: "大红袍",
            image:
              "https://cf.shopee.com.my/file/77a0c44a396309ed01db07adabd9a40b_tn",
            sold: "69 sold",
            create_time: 1637748869000,
            salePrice: "RM5.19",
            price: "RM8.30",
            product_id: 88,
            place: "Penang",
            title:
              "大红袍 火锅底料 麻辣 三鲜 清油火锅 红汤火锅 Steamboat Soup Base MaLaTang/ CleaorOil/ RedSoup/ ThreeDelicacies150g-168gShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//大红袍-火锅底料-麻辣-三鲜-清油火锅-红汤火锅-Steamboat-Soup-Base-MaLaTang-CleaorOil-RedSoup-ThreeDelicacies150g-168g-i.67632715.13110305442?sp_atk=eaf7b906-9e00-45a0-b761-d9b8fd2b1bb9",
            labels: [],
            soldNum: 16,
            review: 0,
            star: 3,
          },
          {
            country: "马来西亚",
            tea: "正山小种",
            image:
              "https://cf.shopee.com.my/file/f134d9420add60ccda852f7ababfb785_tn",
            sold: "234 sold",
            create_time: 1637748869000,
            salePrice: "RM11.66",
            price: "RM16.65",
            product_id: 142,
            place: "Kuala Lumpur",
            title:
              "六大茗茶70克（12小包）铁观音黑乌龙茶.绿茶.金骏眉.大红袍.正山小种茶叶 Assorted Chinese TeaShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//六大茗茶70克（12小包）铁观音黑乌龙茶.绿茶.金骏眉.大红袍.正山小种茶叶-Assorted-Chinese-Tea-i.266929667.4978205463?sp_atk=3a04d4df-be41-4001-aedd-cb3433ab9278",
            labels: [],
            soldNum: 853,
            review: 42,
            star: 4,
          },
          {
            country: "马来西亚",
            tea: "茉莉花",
            image:
              "https://cf.shopee.com.my/file/68906710acf7f0187e967116cc88ace5_tn",
            sold: "17 sold",
            create_time: 1637748869000,
            salePrice: "RM2.59",
            price: "",
            product_id: 31,
            place: "Johor",
            title:
              "农夫山泉 茶兀 茶派 柚子绿茶 玫瑰荔枝红茶 蜜桃乌龙茶 柠檬红茶 西柚茉莉花茶 500ml NongFu Spring Fruit Tea 500mShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//农夫山泉-茶兀-茶派-柚子绿茶-玫瑰荔枝红茶-蜜桃乌龙茶-柠檬红茶-西柚茉莉花茶-500ml-NongFu-Spring-Fruit-Tea-500m-i.277296017.14301040296?sp_atk=9ea11dcb-6b22-442a-8b01-8669751df7b7",
            labels: [],
            soldNum: 973,
            review: 81,
            star: 3,
          },
          {
            country: "马来西亚",
            tea: "大红袍",
            image:
              "https://cf.shopee.com.my/file/db5738eb73e1b111467421f84b8e64b7_tn",
            sold: "67 sold",
            create_time: 1637748869000,
            salePrice: "RM72.21",
            price: "RM83.00",
            product_id: 107,
            place: "Selangor",
            title:
              "武夷山正岩大红袍茶叶武夷岩茶水仙肉桂茶500g浓香型散装礼盒罐装Wuyishan Zhengyan Dahongpao Tea Wuyiyan Tea Narcissus Cinnamon Tea 500g Chinese TeaRM5 offShopMalaysia",
            url:
              "https://my.xiapibuy.com//武夷山正岩大红袍茶叶武夷岩茶水仙肉桂茶500g浓香型散装礼盒罐装Wuyishan-Zhengyan-Dahongpao-Tea-Wuyiyan-Tea-Narcissus-Cinnamon-Tea-500g-Chinese-Tea-i.162023644.5125929393?sp_atk=299fef13-5a69-4a74-b0e5-03a796265428",
            labels: [],
            soldNum: 3378,
            review: 177,
            star: 5,
          },
          {
            country: "马来西亚",
            tea: "正山小种",
            image:
              "https://cf.shopee.com.my/file/0665d3d48c5b6ce25b5c5952b698f438_tn",
            sold: "",
            create_time: 1637748869000,
            salePrice: "RM27.00 - RM61.00",
            price: "",
            product_id: 159,
            place: "Mainland China",
            title:
              "Zhengshan Xiaozhong 2021 new tea super black tea milk tea sp正山小种2021新茶特级红茶奶茶专用蜜香养胃浓香型红茶茶叶批发sxhxdkxx.my9.23RM6 offFree Gift",
            url:
              "https://my.xiapibuy.com//Zhengshan-Xiaozhong-2021-new-tea-super-black-tea-milk-tea-sp正山小种2021新茶特级红茶奶茶专用蜜香养胃浓香型红茶茶叶批发sxhxdkxx.my9.23-i.204153794.13914818402?sp_atk=3db03b5d-0846-4372-897a-d5944d6215fd",
            labels: [],
            soldNum: 4543,
            review: 283,
            star: 4,
          },
          {
            country: "马来西亚",
            tea: "大红袍",
            image:
              "https://cf.shopee.com.my/file/f2ca9597d39b4d0a4e64efa92ba448bd_tn",
            sold: "35.7k sold",
            create_time: 1637748869000,
            salePrice: "RM0.49 - RM0.89",
            price: "",
            product_id: 65,
            place: "Kedah",
            title:
              "【中国茶小袋装】铁观音 大红袍 黑乌龙 普洱 5-7g Chinese TeasShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//【中国茶小袋装】铁观音-大红袍-黑乌龙-普洱-5-7g-Chinese-Teas-i.15549999.9328673007?sp_atk=e34cdc44-b381-4dcc-b5e8-d4608366b2d3",
            labels: [],
            soldNum: 1266,
            review: 66,
            star: 3,
          },
          {
            country: "马来西亚",
            tea: "茉莉花",
            image:
              "https://cf.shopee.com.my/file/73d07c490e781ea19afd3f8f42f74522_tn",
            sold: "",
            create_time: 1637748869000,
            salePrice: "RM2.98",
            price: "RM3.90",
            product_id: 9,
            place: "Selangor",
            title:
              "农夫山泉 茶兀果茶 茶兀 茶派  柚子绿茶/蜜桃乌龙茶/柠檬红茶/西柚茉莉花茶 500ml Nongfu Spring Cha Pai Fruit TeaShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//农夫山泉-茶兀果茶-茶兀-茶派-柚子绿茶-蜜桃乌龙茶-柠檬红茶-西柚茉莉花茶-500ml-Nongfu-Spring-Cha-Pai-Fruit-Tea-i.286624696.13152589206?sp_atk=11abaedb-7cc6-45ad-958e-4cd7df6676c8",
            labels: [],
            soldNum: 4807,
            review: 300,
            star: 3,
          },
          {
            country: "马来西亚",
            tea: "正山小种",
            image:
              "https://cf.shopee.com.my/file/92ba8c56e8af2d82fff92062b2fb8dd3_tn",
            sold: "",
            create_time: 1637748869000,
            salePrice: "RM20.40 - RM81.14",
            price: "",
            product_id: 152,
            place: "Mainland China",
            title:
              "The Small Authentic Martial The Tea Conservation 2021 New Tea Flavor Tea Leaf正山小种正宗武夷山红茶养胃2021新茶浓香型做奶茶叶散袋装nzaldz15.my10.21RM2 offAny 2 enjoy RM1.00 off",
            url:
              "https://my.xiapibuy.com//The-Small-Authentic-Martial-The-Tea-Conservation-2021-New-Tea-Flavor-Tea-Leaf正山小种正宗武夷山红茶养胃2021新茶浓香型做奶茶叶散袋装nzaldz15.my10.21-i.197262226.13233269558?sp_atk=cd023af8-9c87-424a-b25a-823ba24f2a85",
            labels: [],
            soldNum: 453,
            review: 34,
            star: 3,
          },
          {
            country: "马来西亚",
            tea: "大红袍",
            image:
              "https://cf.shopee.com.my/file/5f8439936804e7040b6b6963a62d4185_tn",
            sold: "4.9k sold",
            create_time: 1637748869000,
            salePrice: "RM0.45",
            price: "RM2.00",
            product_id: 66,
            place: "Kuala Lumpur",
            title:
              "{READY STOCK}{中国茶小袋装} 大红袍 铁观音 金骏眉 黑乌龙 普洱茶 6-8g Individual Pack Chinese Tea Tie Guan Yin Da Hong Pao Jasmine Tea Teh CinaShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//-READY-STOCK-中国茶小袋装-大红袍-铁观音-金骏眉-黑乌龙-普洱茶-6-8g-Individual-Pack-Chinese-Tea-Tie-Guan-Yin-Da-Hong-Pao-Jasmine-Tea-Teh-Cina-i.421424331.6297246712?sp_atk=3fedc089-d6b2-493e-935b-76937b99e96a",
            labels: [],
            soldNum: 1802,
            review: 180,
            star: 3,
          },
          {
            country: "马来西亚",
            tea: "正山小种",
            image:
              "https://cf.shopee.com.my/file/cfb45424f15a59c6f38a5baa7f87a82a_tn",
            sold: "7 sold",
            create_time: 1637748869000,
            salePrice: "RM27.50 - RM53.10",
            price: "",
            product_id: 127,
            place: "Mainland China",
            title:
              "金骏眉正山小种250g/500g茶叶红茶Jinjunmei Zhengshan Race 250g/500g Tea Black TeaRM2 offCOD",
            url:
              "https://my.xiapibuy.com//金骏眉正山小种250g-500g茶叶红茶Jinjunmei-Zhengshan-Race-250g-500g-Tea-Black-Tea-i.513884826.11930571021?sp_atk=c5ea52a0-7552-4232-be4a-aa11fa756cbb",
            labels: [],
            soldNum: 2708,
            review: 225,
            star: 5,
          },
          {
            country: "马来西亚",
            tea: "正山小种",
            image:
              "https://cf.shopee.com.my/file/a69fe7378dba45c1638db534478e6a73_tn",
            sold: "7 sold",
            create_time: 1637748869000,
            salePrice: "RM4.00 - RM18.85",
            price: "",
            product_id: 167,
            place: "Mainland China",
            title:
              "Tea caddy  现货速发  小罐散茶罐  空铝罐  白毫银针  正山小种绿茶  白茶便携  马口铁茶  叶罐包装COD",
            url:
              "https://my.xiapibuy.com//Tea-caddy-现货速发-小罐散茶罐-空铝罐-白毫银针-正山小种绿茶-白茶便携-马口铁茶-叶罐包装-i.433757760.4990430435?sp_atk=6911171c-143e-4634-9721-ac79a7904fd1",
            labels: [],
            soldNum: 1201,
            review: 92,
            star: 3,
          },
          {
            country: "马来西亚",
            tea: "茉莉花",
            image:
              "https://cf.shopee.com.my/file/c573b49ae824ec969b6dc056543d53f0_tn",
            sold: "15.8k sold",
            create_time: 1637748869000,
            salePrice: "RM0.48 - RM0.85",
            price: "",
            product_id: 8,
            place: "Kuala Lumpur",
            title:
              "????现货????优惠价 散装中国茶 大红袍 铁观音 普洱熟茶 黑乌龙 龙井茶 小种红茶 茉莉花茶 高山绿茶 炭焙铁观音 碧螺春 金俊眉 金丝皇菊 菊花茶 茶叶 Chinese Tea Da Hong Pao Tie Guan Yin Pu erShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//????现货????优惠价-散装中国茶-大红袍-铁观音-普洱熟茶-黑乌龙-龙井茶-小种红茶-茉莉花茶-高山绿茶-炭焙铁观音-碧螺春-金俊眉-金丝皇菊-菊花茶-茶叶-Chinese-Tea-Da-Hong-Pao-Tie-Guan-Yin-Pu-er-i.128031579.11920308453?sp_atk=653d8cad-2a7e-403c-8d1d-de6b234286ef",
            labels: [],
            soldNum: 3460,
            review: 182,
            star: 4,
          },
          {
            country: "马来西亚",
            tea: "正山小种",
            image:
              "https://cf.shopee.com.my/file/c6ac6bd7f3863efac41ab32e1e9b4882_tn",
            sold: "",
            create_time: 1637748869000,
            salePrice: "RM15.84 - RM47.36",
            price: "",
            product_id: 130,
            place: "Melaka",
            title:
              "Ye Song Tea Black Tea Lapsang Souchong J叶颂茶叶 红茶正山小种金骏眉 大红袍 铁观音多款任选 礼盒装新茶lrw3f3ycn7Local SellerCOD",
            url:
              "https://my.xiapibuy.com//Ye-Song-Tea-Black-Tea-Lapsang-Souchong-J叶颂茶叶-红茶正山小种金骏眉-大红袍-铁观音多款任选-礼盒装新茶lrw3f3ycn7-i.431042679.13004573231?sp_atk=d8ef0cdc-6e72-47fb-b417-c5b967202870",
            labels: [],
            soldNum: 2515,
            review: 132,
            star: 5,
          },
          {
            country: "马来西亚",
            tea: "茉莉花",
            image:
              "https://cf.shopee.com.my/file/7231b6ab83defc316bbf5d64d6661e7f_tn",
            sold: "2.6k sold",
            create_time: 1637748869000,
            salePrice: "RM50.00",
            price: "RM75.00",
            product_id: 26,
            place: "Selangor",
            title:
              "中国茶叶 Chinese tea Teh 【100g x 3】 绿茶 大红袍 普洱 铁观音 黄金桂 水仙 乌龙茶 茉莉花茶 红茶 Puer Tea Green tea Black tea Jasmine Tea Tie guan yinShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//中国茶叶-Chinese-tea-Teh-【100g-x-3】-绿茶-大红袍-普洱-铁观音-黄金桂-水仙-乌龙茶-茉莉花茶-红茶-Puer-Tea-Green-tea-Black-tea-Jasmine-Tea-Tie-guan-yin-i.142200712.7006322272?sp_atk=d1745805-d224-4c41-8929-f45a1f2578e3",
            labels: [],
            soldNum: 3091,
            review: 237,
            star: 5,
          },
          {
            country: "马来西亚",
            tea: "大红袍",
            image:
              "https://cf.shopee.com.my/file/83fcb079c825e3c2b7aa9e25aafbf3b7_tn",
            sold: "148 sold",
            create_time: 1637748869000,
            salePrice: "RM33.73 - RM44.98",
            price: "",
            product_id: 83,
            place: "Mainland China",
            title:
              "Wuyishan Zhengyan Dahongpao Tea New Tea Luzhou-flavored Cinn武夷山正岩大红袍茶叶新茶浓香型肉桂春茶高山乌龙茶散装罐装250gweixianyuanming.myEconomyDeliveryFree Gift",
            url:
              "https://my.xiapibuy.com//Wuyishan-Zhengyan-Dahongpao-Tea-New-Tea-Luzhou-flavored-Cinn武夷山正岩大红袍茶叶新茶浓香型肉桂春茶高山乌龙茶散装罐装250gweixianyuanming.my-i.202931586.9017785784?sp_atk=025f6f5d-5c55-44db-8c01-2561c1a76fcb",
            labels: [],
            soldNum: 1709,
            review: 106,
            star: 5,
          },
          {
            country: "马来西亚",
            tea: "正山小种",
            image:
              "https://cf.shopee.com.my/file/b3a1dfa13bda919bb37bc081fa6441c1_tn",
            sold: "",
            create_time: 1637748869000,
            salePrice: "RM36.00 - RM71.00",
            price: "",
            product_id: 140,
            place: "Mainland China",
            title:
              "[give one pot and four cups] Jin Junmei Zhengshan seed 250G / 500g tea black tea�【赠一壶四杯】金骏眉正山小种250g/500g茶叶红茶礼盒装罐装散装blxy017.my21.10.26RM5 offEconomyDelivery",
            url:
              "https://my.xiapibuy.com//-give-one-pot-and-four-cups-Jin-Junmei-Zhengshan-seed-250G-500g-tea-black-tea�【赠一壶四杯】金骏眉正山小种250g-500g茶叶红茶礼盒装罐装散装blxy017.my21.10.26-i.208632003.11364313407?sp_atk=b272a682-b45f-4761-9dc7-5ea7228f7f4e",
            labels: [],
            soldNum: 801,
            review: 53,
            star: 5,
          },
          {
            country: "马来西亚",
            tea: "正山小种",
            image:
              "https://cf.shopee.com.my/file/cc067c5d681605dcbe367bea6d94c98e_tn",
            sold: "7 sold",
            create_time: 1637748869000,
            salePrice: "RM11.00 - RM33.50",
            price: "",
            product_id: 178,
            place: "Mainland China",
            title:
              "新茶武夷山正山小种红茶罐装桐木关金骏眉茶叶New Tea Wuyishan Zhengshan Race Black Tea Canned Tongmuguan Jinjunmei TeaCODAdd-on Deal",
            url:
              "https://my.xiapibuy.com//新茶武夷山正山小种红茶罐装桐木关金骏眉茶叶New-Tea-Wuyishan-Zhengshan-Race-Black-Tea-Canned-Tongmuguan-Jinjunmei-Tea-i.513884826.10830566875?sp_atk=327dd710-d498-4c27-9f26-f8d38f78d827",
            labels: [],
            soldNum: 1129,
            review: 70,
            star: 4,
          },
          {
            country: "马来西亚",
            tea: "大红袍",
            image:
              "https://cf.shopee.com.my/file/4f4cb5b8c6505eb4d513456e26b9536b_tn",
            sold: "162 sold",
            create_time: 1637748869000,
            salePrice: "RM15.88 - RM18.88",
            price: "",
            product_id: 114,
            place: "Selangor",
            title:
              "普洱茶 金骏眉 正山小种 大红袍 铁观音 茉莉花茶 高山绿茶 碧螺春 黄金桂茶 黑乌龙茶 龙景绿茶 毛尖 炭焙铁观音 奇兰 老叢水仙 肉桂 凤凰單叢 茶叶 chinese tea health Puer Da Hong Pao OolongShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//普洱茶-金骏眉-正山小种-大红袍-铁观音-茉莉花茶-高山绿茶-碧螺春-黄金桂茶-黑乌龙茶-龙景绿茶-毛尖-炭焙铁观音-奇兰-老叢水仙-肉桂-凤凰單叢-茶叶-chinese-tea-health-Puer-Da-Hong-Pao-Oolong-i.653343.9513923540?sp_atk=3172ac23-1bee-4700-aa7f-6e0156c6d3ba",
            labels: [],
            soldNum: 3400,
            review: 283,
            star: 4,
          },
          {
            country: "马来西亚",
            tea: "大红袍",
            image:
              "https://cf.shopee.com.my/file/344fc23ca43122f2c311d8d1d816371f_tn",
            sold: "2 sold",
            create_time: 1637748869000,
            salePrice: "RM33.50 - RM60.20",
            price: "",
            product_id: 119,
            place: "Mainland China",
            title:
              "【 武夷山大红袍】正岩岩茶 浓香型肉桂 水仙奇兰 盒装250g 【Wuyishan Dahongpao】 Zhengyan Rock Tea Luzhou-flavor Cinnamon Narcissus Chilan Boxed 250g.RM2 offCOD",
            url:
              "https://my.xiapibuy.com//【-武夷山大红袍】正岩岩茶-浓香型肉桂-水仙奇兰-盒装250g-【Wuyishan-Dahongpao】-Zhengyan-Rock-Tea-Luzhou-flavor-Cinnamon-Narcissus-Chilan-Boxed-250g.-i.513884826.11859947689?sp_atk=dbd801b3-d20a-4bc9-9b81-49aabe601372",
            labels: [],
            soldNum: 1886,
            review: 188,
            star: 5,
          },
          {
            country: "马来西亚",
            tea: "正山小种",
            image:
              "https://cf.shopee.com.my/file/086acfa818c7f5ac7c3d5ceea157457b_tn",
            sold: "",
            create_time: 1637748869000,
            salePrice: "RM15.99",
            price: "RM16.50",
            product_id: 137,
            place: "Melaka",
            title:
              "铁罐装茶叶 碧螺春 普洱茶 正山小种 金骏眉 茉莉花茶 铁观音 绿茶 大红袍 中国茶叶 #chinese tea #各类式 #名茶 #浓香ShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//铁罐装茶叶-碧螺春-普洱茶-正山小种-金骏眉-茉莉花茶-铁观音-绿茶-大红袍-中国茶叶-chinese-tea-各类式-名茶-浓香-i.396483765.10770414275?sp_atk=dfe68040-e11a-4519-a4e3-775f44d6b4bd",
            labels: [],
            soldNum: 2446,
            review: 203,
            star: 5,
          },
          {
            country: "马来西亚",
            tea: "茉莉花",
            image:
              "https://cf.shopee.com.my/file/06fc59a4a0bf919f3feee2f4976a1c23_tn",
            sold: "3 sold",
            create_time: 1637748869000,
            salePrice: "RM3.90",
            price: "",
            product_id: 35,
            place: "Selangor",
            title:
              "农夫山泉东方树叶红茶茉莉花茶乌龙茶绿茶无糖乌龙茶饮料Black Tea/Jasmine Tea/Oolong Tea/Green TeaShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//农夫山泉东方树叶红茶茉莉花茶乌龙茶绿茶无糖乌龙茶饮料Black-Tea-Jasmine-Tea-Oolong-Tea-Green-Tea-i.43656429.11541399688?sp_atk=ccc5dcce-0791-487f-ab3f-f7ac70a3aada",
            labels: [],
            soldNum: 3306,
            review: 275,
            star: 4,
          },
          {
            country: "马来西亚",
            tea: "大红袍",
            image:
              "https://cf.shopee.com.my/file/f30bd01cfa39ca1f121e807718144767_tn",
            sold: "3.3k sold",
            create_time: 1637748869000,
            salePrice: "RM1.01",
            price: "RM5.00",
            product_id: 75,
            place: "Negeri Sembilan",
            title:
              "武夷山大红袍 5g 中国茶 Dahongpao Tea 1 pack 5g(26 packs=1box)ShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//武夷山大红袍-5g-中国茶-Dahongpao-Tea-1-pack-5g(26-packs-1box)-i.26435989.4967239930?sp_atk=87039b3d-61ce-47b8-aeda-ce37f921b65c",
            labels: [],
            soldNum: 2163,
            review: 108,
            star: 3,
          },
          {
            country: "马来西亚",
            tea: "正山小种",
            image:
              "https://cf.shopee.com.my/file/cb83f79b2c5e8929e0249fd6f23ac66a_tn",
            sold: "",
            create_time: 1637748869000,
            salePrice: "RM14.50",
            price: "",
            product_id: 154,
            place: "Terengganu",
            title:
              "正山小种茶（50gX10小包）Lapsang Souchong Tea24% offShopMalaysia",
            url:
              "https://my.xiapibuy.com//正山小种茶（50gX10小包）Lapsang-Souchong-Tea-i.511960624.12030818854?sp_atk=86d80743-7ebf-41e5-a390-4cac13b71a0e",
            labels: [],
            soldNum: 4620,
            review: 420,
            star: 5,
          },
          {
            country: "马来西亚",
            tea: "正山小种",
            image:
              "https://cf.shopee.com.my/file/9b029df4ecdafa2f7d102f422c61ae0b_tn",
            sold: "2 sold",
            create_time: 1637748869000,
            salePrice: "RM107.00",
            price: "RM214.50",
            product_id: 176,
            place: "Mainland China",
            title:
              "送茶具正山小种茶叶正宗武夷山金骏眉新茶长辈送礼红茶礼盒装Send Tea Set Zhengshan Race Tea Authentic Wuyishan Jinjunmei New Tea Elder Gift Black Tea Gift BoxCOD",
            url:
              "https://my.xiapibuy.com//送茶具正山小种茶叶正宗武夷山金骏眉新茶长辈送礼红茶礼盒装Send-Tea-Set-Zhengshan-Race-Tea-Authentic-Wuyishan-Jinjunmei-New-Tea-Elder-Gift-Black-Tea-Gift-Box-i.513884826.9790577490?sp_atk=f04e86b3-8897-4cd2-a459-f712c8be1bee",
            labels: [],
            soldNum: 2401,
            review: 171,
            star: 4,
          },
          {
            country: "马来西亚",
            tea: "大红袍",
            image:
              "https://cf.shopee.com.my/file/5bcf7437fdcd509465c9f7c03721523e_tn",
            sold: "5 sold",
            create_time: 1637748869000,
            salePrice: "RM36.80 - RM67.90",
            price: "",
            product_id: 89,
            place: "Mainland China",
            title:
              "红茶武夷山特级岩茶熟茶大红袍浓香型茶叶礼盒装罐装送礼新茶 Black Tea Wuyishan Super Rock Tea Cooked Tea Dahongpao Luzhou-flavor Tea Gift Box Canned Gift-giving New Tea.RM5 offCOD",
            url:
              "https://my.xiapibuy.com//红茶武夷山特级岩茶熟茶大红袍浓香型茶叶礼盒装罐装送礼新茶-Black-Tea-Wuyishan-Super-Rock-Tea-Cooked-Tea-Dahongpao-Luzhou-flavor-Tea-Gift-Box-Canned-Gift-giving-New-Tea.-i.513884826.12105475755?sp_atk=84e2267c-a080-4b5d-abd9-d4a24fec1c40",
            labels: [],
            soldNum: 472,
            review: 36,
            star: 4,
          },
          {
            country: "马来西亚",
            tea: "大红袍",
            image:
              "https://cf.shopee.com.my/file/3e5156546dc9ab257b8f5eabe04a2255_tn",
            sold: "20 sold",
            create_time: 1637748869000,
            salePrice: "RM1.50 - RM3.50",
            price: "",
            product_id: 71,
            place: "Penang",
            title:
              "大红袍茶叶创意随手礼盒牛皮纸简易通用折叠单双提Dahongpao tea creative handy gift box kraft paper simple universal folding single and double liftShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//大红袍茶叶创意随手礼盒牛皮纸简易通用折叠单双提Dahongpao-tea-creative-handy-gift-box-kraft-paper-simple-universal-folding-single-and-double-lift-i.24094122.13352334674?sp_atk=6091d2f0-e4c6-47bf-8329-d2b596094d39",
            labels: [],
            soldNum: 4275,
            review: 225,
            star: 5,
          },
          {
            country: "马来西亚",
            tea: "茉莉花",
            image:
              "https://cf.shopee.com.my/file/2b01dccb7ec5eee9249e5f51fa587c77_tn",
            sold: "64 sold",
            create_time: 1637748869000,
            salePrice: "RM2.50",
            price: "",
            product_id: 16,
            place: "Sarawak",
            title:
              "香喷喷的茉莉花茶   Jasmine Tea☜100gShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//香喷喷的茉莉花茶-Jasmine-Tea☜100g-i.69282524.5739976485?sp_atk=0344ec89-9e20-4552-94b2-4e2418c013d3",
            labels: [],
            soldNum: 2455,
            review: 163,
            star: 5,
          },
          {
            country: "马来西亚",
            tea: "茉莉花",
            image:
              "https://cf.shopee.com.my/file/00099179b17f2eeab6161a2a0a15f47b_tn",
            sold: "648 sold",
            create_time: 1637748869000,
            salePrice: "RM20.00",
            price: "",
            product_id: 6,
            place: "Selangor",
            title:
              "茉莉花茶 9601 Jasmine Tea 9601 【1kg】|【花茶 Scented tea】 Chinese Tea  中国茶叶 Jasmine Green tea 香片 Teh Cina 中国茶  茶叶  茶 茉莉花ShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//茉莉花茶-9601-Jasmine-Tea-9601-【1kg】-【花茶-Scented-tea】-Chinese-Tea-中国茶叶-Jasmine-Green-tea-香片-Teh-Cina-中国茶-茶叶-茶-茉莉花-i.142200712.4315652146?sp_atk=a38aa087-f6c8-428a-910b-9789d2866fa0",
            labels: [],
            soldNum: 492,
            review: 41,
            star: 4,
          },
          {
            country: "马来西亚",
            tea: "大红袍",
            image:
              "https://cf.shopee.com.my/file/5a4b7c2cf3ed6ac85d6e803a0aee95fd_tn",
            sold: "494 sold",
            create_time: 1637748869000,
            salePrice: "RM1.00",
            price: "RM1.40",
            product_id: 115,
            place: "Kuala Lumpur",
            title:
              "Dahongpao Tea [ High Quality ] 武夷山大红袍中国茶一包ShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//Dahongpao-Tea-High-Quality-武夷山大红袍中国茶一包-i.10534598.6258664132?sp_atk=d9b057cb-a870-4460-a97f-55ea5caf5f3d",
            labels: [],
            soldNum: 3216,
            review: 189,
            star: 3,
          },
          {
            country: "马来西亚",
            tea: "茉莉花",
            image:
              "https://cf.shopee.com.my/file/4bdac61f6c9dc175a7bb9c329cbaf7b0_tn",
            sold: "18.8k sold",
            create_time: 1637748869000,
            salePrice: "RM2.70",
            price: "",
            product_id: 53,
            place: "Selangor",
            title:
              "农夫山泉 茶兀饮料  500ml 蜜桃乌龙茶 西柚茉莉花茶 柠檬红茶 玫瑰荔枝红茶 柚子绿茶 Nongfu Spring Tea DrinksShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//农夫山泉-茶兀饮料-500ml-蜜桃乌龙茶-西柚茉莉花茶-柠檬红茶-玫瑰荔枝红茶-柚子绿茶-Nongfu-Spring-Tea-Drinks-i.84694438.9243308046?sp_atk=b62f673c-daf6-42ab-8a27-edbcf3c95096",
            labels: [],
            soldNum: 4537,
            review: 412,
            star: 5,
          },
          {
            country: "马来西亚",
            tea: "茉莉花",
            image:
              "https://cf.shopee.com.my/file/76389cb88c4fc1b951faca45f67f154a_tn",
            sold: "223 sold",
            create_time: 1637748869000,
            salePrice: "RM7.50 - RM9.90",
            price: "",
            product_id: 29,
            place: "Johor",
            title:
              "渝达 天然养生花茶 三角茶包 脂流茶柠檬山楂荷叶茶 Herbal Rose Peach Oolong Flower Tea 薄荷绿茶 白蜜桃乌龙茶 桂花乌龙茶 茉莉薄荷茶 玫瑰红茶 茉莉绿茶 红豆薏米 菊花决明子 Black TeaShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//渝达-天然养生花茶-三角茶包-脂流茶柠檬山楂荷叶茶-Herbal-Rose-Peach-Oolong-Flower-Tea-薄荷绿茶-白蜜桃乌龙茶-桂花乌龙茶-茉莉薄荷茶-玫瑰红茶-茉莉绿茶-红豆薏米-菊花决明子-Black-Tea-i.99094.3391347066?sp_atk=27f60e8a-814f-42df-89f3-acf614ac8c31",
            labels: [],
            soldNum: 3485,
            review: 248,
            star: 5,
          },
          {
            country: "马来西亚",
            tea: "大红袍",
            image:
              "https://cf.shopee.com.my/file/c573b49ae824ec969b6dc056543d53f0_tn",
            sold: "15.8k sold",
            create_time: 1637748869000,
            salePrice: "RM0.48 - RM0.85",
            price: "",
            product_id: 82,
            place: "Kuala Lumpur",
            title:
              "????现货????优惠价 散装中国茶 大红袍 铁观音 普洱熟茶 黑乌龙 龙井茶 小种红茶 茉莉花茶 高山绿茶 炭焙铁观音 碧螺春 金俊眉 金丝皇菊 菊花茶 茶叶 Chinese Tea Da Hong Pao Tie Guan Yin Pu erShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//????现货????优惠价-散装中国茶-大红袍-铁观音-普洱熟茶-黑乌龙-龙井茶-小种红茶-茉莉花茶-高山绿茶-炭焙铁观音-碧螺春-金俊眉-金丝皇菊-菊花茶-茶叶-Chinese-Tea-Da-Hong-Pao-Tie-Guan-Yin-Pu-er-i.128031579.11920308453?sp_atk=eab1ece7-19f7-4a98-a926-a7aa06e25d74",
            labels: [],
            soldNum: 2773,
            review: 154,
            star: 5,
          },
          {
            country: "马来西亚",
            tea: "正山小种",
            image:
              "https://cf.shopee.com.my/file/e20cde044b6fa7c4db293bb3e4933f98_tn",
            sold: "",
            create_time: 1637748869000,
            salePrice: "RM19.35 - RM62.03",
            price: "",
            product_id: 170,
            place: "Mainland China",
            title:
              "【红茶】新茶 金骏眉小包装茶叶 蜜香武夷山正山小种 黄芽浓香型 礼盒装 【Black Tea】 New Tea Jinjunmei Small Package Tea Honey Fragrance Wuyishan Zhengshan Race Yellow Bud Luzhou-flavor Gift Box.RM2 offCOD",
            url:
              "https://my.xiapibuy.com//【红茶】新茶-金骏眉小包装茶叶-蜜香武夷山正山小种-黄芽浓香型-礼盒装-【Black-Tea】-New-Tea-Jinjunmei-Small-Package-Tea-Honey-Fragrance-Wuyishan-Zhengshan-Race-Yellow-Bud-Luzhou-flavor-Gift-Box.-i.513884826.12939310106?sp_atk=412cd17f-b6a8-4601-b4dd-9caba9ea073b",
            labels: [],
            soldNum: 180,
            review: 11,
            star: 3,
          },
          {
            country: "马来西亚",
            tea: "大红袍",
            image:
              "https://cf.shopee.com.my/file/7231b6ab83defc316bbf5d64d6661e7f_tn",
            sold: "2.6k sold",
            create_time: 1637748869000,
            salePrice: "RM50.00",
            price: "RM75.00",
            product_id: 64,
            place: "Selangor",
            title:
              "中国茶叶 Chinese tea Teh 【100g x 3】 绿茶 大红袍 普洱 铁观音 黄金桂 水仙 乌龙茶 茉莉花茶 红茶 Puer Tea Green tea Black tea Jasmine Tea Tie guan yinShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//中国茶叶-Chinese-tea-Teh-【100g-x-3】-绿茶-大红袍-普洱-铁观音-黄金桂-水仙-乌龙茶-茉莉花茶-红茶-Puer-Tea-Green-tea-Black-tea-Jasmine-Tea-Tie-guan-yin-i.142200712.7006322272?sp_atk=9006eeed-798d-4823-8a3b-0f4b7a60f94c",
            labels: [],
            soldNum: 3518,
            review: 206,
            star: 4,
          },
          {
            country: "马来西亚",
            tea: "大红袍",
            image:
              "https://cf.shopee.com.my/file/2e3b3a3829d6cb2501102148c7787dbe_tn",
            sold: "36 sold",
            create_time: 1637748869000,
            salePrice: "RM20.70",
            price: "RM42.30",
            product_id: 70,
            place: "Mainland China",
            title:
              "[武夷岩茶大红袍]茶叶礼盒250g罐装炭焙浓香乌龙茶春茶岩茶肉桂红茶中国茶[Wuyi Rock Tea Dahongpao] Tea Gift Box 250g Canned Carbon Baked Luzhou Oolong Tea Spring Tea Rock Tea Cinnamon Black Tea Chinese TeaRM2 offCOD",
            url:
              "https://my.xiapibuy.com//-武夷岩茶大红袍-茶叶礼盒250g罐装炭焙浓香乌龙茶春茶岩茶肉桂红茶中国茶-Wuyi-Rock-Tea-Dahongpao-Tea-Gift-Box-250g-Canned-Carbon-Baked-Luzhou-Oolong-Tea-Spring-Tea-Rock-Tea-Cinnamon-Black-Tea-Chinese-Tea-i.513884826.10041732363?sp_atk=32e64c27-ba0c-4dd8-861c-0cfebd",
            labels: [],
            soldNum: 4841,
            review: 484,
            star: 4,
          },
          {
            country: "马来西亚",
            tea: "大红袍",
            image:
              "https://cf.shopee.com.my/file/417397d3ed218a9321ef0378aa325e0e_tn",
            sold: "71 sold",
            create_time: 1637748869000,
            salePrice: "RM19.88",
            price: "",
            product_id: 120,
            place: "Selangor",
            title:
              "Da Hong Pao Tea(Oolong Tea)  a pack 200g 乌龙茶武夷岩茶大红袍ShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//Da-Hong-Pao-Tea(Oolong-Tea)-a-pack-200g-乌龙茶武夷岩茶大红袍-i.155958055.3917306360?sp_atk=52cacfa0-688a-4cb1-8aed-67fce6b4bfc4",
            labels: [],
            soldNum: 1184,
            review: 107,
            star: 4,
          },
          {
            country: "马来西亚",
            tea: "茉莉花",
            image:
              "https://cf.shopee.com.my/file/d9f5f1374ad3dc79a513394c41f64570_tn",
            sold: "47 sold",
            create_time: 1637748869000,
            salePrice: "RM10.50",
            price: "RM10.90",
            product_id: 12,
            place: "Penang",
            title:
              "Jasmine Tea Flower Tea 100g 浓香型茉莉花茶浓香小白豪 花茶RM1 offShopMalaysia",
            url:
              "https://my.xiapibuy.com//Jasmine-Tea-Flower-Tea-100g-浓香型茉莉花茶浓香小白豪-花茶-i.60201032.8749449249?sp_atk=f2a9d2c8-d6ec-4d45-b0cd-0cf8235696f1",
            labels: [],
            soldNum: 1470,
            review: 91,
            star: 3,
          },
          {
            country: "马来西亚",
            tea: "正山小种",
            image:
              "https://cf.shopee.com.my/file/57375897649eef3d0246fe128656abba_tn",
            sold: "",
            create_time: 1637748869000,
            salePrice: "RM351.44",
            price: "RM585.73",
            product_id: 168,
            place: "Mainland China",
            title:
              "Eight horses lapsang souchong tea level wuyi tea large quant八马茶叶 一级正山小种武夷山红茶大份量商务高端送礼礼盒装500g10.17RM15 off",
            url:
              "https://my.xiapibuy.com//Eight-horses-lapsang-souchong-tea-level-wuyi-tea-large-quant八马茶叶-一级正山小种武夷山红茶大份量商务高端送礼礼盒装500g10.17-i.189804488.9795473419?sp_atk=ce509e76-fb30-4621-8dcc-f48a69d83608",
            labels: [],
            soldNum: 910,
            review: 50,
            star: 5,
          },
          {
            country: "马来西亚",
            tea: "正山小种",
            image:
              "https://cf.shopee.com.my/file/d89a20c268eb8fc6df54fc58416e2211_tn",
            sold: "3 sold",
            create_time: 1637748869000,
            salePrice: "RM68.00 - RM82.00",
            price: "",
            product_id: 172,
            place: "Mainland China",
            title:
              "Holiday gift Dahongpao tea gift box Wuyishan Lapsang Souchon节日礼 大红袍茶叶礼盒装 武夷山正山小种 金骏眉红茶肉桂散装????抽BOSS百货店????Free Gift",
            url:
              "https://my.xiapibuy.com//Holiday-gift-Dahongpao-tea-gift-box-Wuyishan-Lapsang-Souchon节日礼-大红袍茶叶礼盒装-武夷山正山小种-金骏眉红茶肉桂散装????抽BOSS百货店????-i.427603284.8949396338?sp_atk=6966c5b4-3dec-4f24-aef6-2cb1168a1afd",
            labels: [],
            soldNum: 853,
            review: 47,
            star: 4,
          },
          {
            country: "马来西亚",
            tea: "茉莉花",
            image:
              "https://cf.shopee.com.my/file/f8e70c66fa49bfe37bcfe3db196117ca_tn",
            sold: "9 sold",
            create_time: 1637748869000,
            salePrice: "RM8.99",
            price: "RM12.90",
            product_id: 44,
            place: "Selangor",
            title:
              "Matcharo Jasmine Green Tea (10 tea bag) 花茶- 茉莉绿茶ShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//Matcharo-Jasmine-Green-Tea-(10-tea-bag)-花茶-茉莉绿茶-i.53852994.4484044181?sp_atk=ca44ade1-7063-4b23-9a92-dcaa31fd6a4b",
            labels: [],
            soldNum: 4480,
            review: 320,
            star: 3,
          },
          {
            country: "马来西亚",
            tea: "茉莉花",
            image:
              "https://cf.shopee.com.my/file/4829bf1aa08e9ccd18caa1fa0e1ed939_tn",
            sold: "165 sold",
            create_time: 1637748869000,
            salePrice: "RM30.00",
            price: "",
            product_id: 48,
            place: "Selangor",
            title:
              "茉莉花茶 9501 Jasmine Tea 9501 【1kg】|【花茶 Scented tea】 Chinese Tea  中国茶叶 Jasmine Green tea 香片 Teh Cina 中国茶  茶叶  茶 茉莉花ShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//茉莉花茶-9501-Jasmine-Tea-9501-【1kg】-【花茶-Scented-tea】-Chinese-Tea-中国茶叶-Jasmine-Green-tea-香片-Teh-Cina-中国茶-茶叶-茶-茉莉花-i.142200712.4915652376?sp_atk=51565d9d-65b8-4c3f-a850-22f675ba62eb",
            labels: [],
            soldNum: 492,
            review: 30,
            star: 3,
          },
          {
            country: "马来西亚",
            tea: "大红袍",
            image:
              "https://cf.shopee.com.my/file/e5277481bd32fd83e3413f1ffb90438d_tn",
            sold: "644 sold",
            create_time: 1637748869000,
            salePrice: "RM0.85",
            price: "",
            product_id: 103,
            place: "Selangor",
            title:
              "Wuyi Tea 武夷山岩茶叶（大红袍, 肉桂，水仙，奇兰）ShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//Wuyi-Tea-武夷山岩茶叶（大红袍-肉桂，水仙，奇兰）-i.107485006.9860230280?sp_atk=f65ddb87-ef09-4c87-965a-581e236486d3",
            labels: [],
            soldNum: 870,
            review: 79,
            star: 5,
          },
          {
            country: "马来西亚",
            tea: "大红袍",
            image:
              "https://cf.shopee.com.my/file/3b495fce46d45b283f906962fc0780a2_tn",
            sold: "595 sold",
            create_time: 1637748869000,
            salePrice: "RM25.00",
            price: "",
            product_id: 95,
            place: "Selangor",
            title:
              "岩骨花香大红袍 Yan Gu Hua Xiang Da Hong Pao 【100g】|【 武夷岩茶 Wu Yi Rock Tea 】 Oolong tea Teh Cina  中国茶叶 Chinese Tea 中国茶  茶叶  茶ShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//岩骨花香大红袍-Yan-Gu-Hua-Xiang-Da-Hong-Pao-【100g】-【-武夷岩茶-Wu-Yi-Rock-Tea-】-Oolong-tea-Teh-Cina-中国茶叶-Chinese-Tea-中国茶-茶叶-茶-i.142200712.6442200049?sp_atk=68b6193d-fde8-49d4-a744-46ac22baf04e",
            labels: [],
            soldNum: 3290,
            review: 182,
            star: 4,
          },
          {
            country: "马来西亚",
            tea: "正山小种",
            image:
              "https://cf.shopee.com.my/file/f84190775de272992f5a667002af4c8b_tn",
            sold: "",
            create_time: 1637748869000,
            salePrice: "RM40.00 - RM67.00",
            price: "",
            product_id: 155,
            place: "Mainland China",
            title:
              "【 Zhengshan race 】 super stomach nourishing black tea authentic Luzhou flavor bu�【正山小种】特级养胃红茶正宗浓香型散装高山茶叶新茶散装袋装jiumei10.my21.10.31RM5 off",
            url:
              "https://my.xiapibuy.com//【-Zhengshan-race-】-super-stomach-nourishing-black-tea-authentic-Luzhou-flavor-bu�【正山小种】特级养胃红茶正宗浓香型散装高山茶叶新茶散装袋装jiumei10.my21.10.31-i.427603284.12940481775?sp_atk=6b940afc-a66d-4abc-b2c3-f5405e52de65",
            labels: [],
            soldNum: 257,
            review: 19,
            star: 4,
          },
          {
            country: "马来西亚",
            tea: "茉莉花",
            image:
              "https://cf.shopee.com.my/file/c9710025c5c0828ef779038cd79b031b_tn",
            sold: "595 sold",
            create_time: 1637748869000,
            salePrice: "RM25.00",
            price: "",
            product_id: 42,
            place: "Selangor",
            title:
              "茉莉花茶 Jasmine Tea 【100g】 |【花茶 Scented tea】 Chinese Tea 中国茶叶 Teh Cina 中国茶  茶叶  茶ShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//茉莉花茶-Jasmine-Tea-【100g】-【花茶-Scented-tea】-Chinese-Tea-中国茶叶-Teh-Cina-中国茶-茶叶-茶-i.142200712.4504541855?sp_atk=0f2a9c90-2871-4b95-95ae-b2fe81a64bd6",
            labels: [],
            soldNum: 4857,
            review: 346,
            star: 3,
          },
          {
            country: "马来西亚",
            tea: "正山小种",
            image:
              "https://cf.shopee.com.my/file/5a2cb1dcef531440d1775bc23eb48cc6_tn",
            sold: "",
            create_time: 1637748869000,
            salePrice: "RM38.00",
            price: "RM98.00",
            product_id: 179,
            place: "Kuala Lumpur",
            title:
              "璞卉精选武夷山正山小种茶罐装红茶中国名茶PohHuey selection, Wuyishan, Lapsang Souchong tea, canned black tea, Chinese famous teaCOD",
            url:
              "https://my.xiapibuy.com//璞卉精选武夷山正山小种茶罐装红茶中国名茶PohHuey-selection-Wuyishan-Lapsang-Souchong-tea-canned-black-tea-Chinese-famous-tea-i.515626905.13224784986?sp_atk=eeb0b949-1cc1-4099-a0f0-f1d32b47e4dc",
            labels: [],
            soldNum: 4763,
            review: 476,
            star: 4,
          },
          {
            country: "马来西亚",
            tea: "茉莉花",
            image:
              "https://cf.shopee.com.my/file/4442f92f640569b2e39e052323754126_tn",
            sold: "51 sold",
            create_time: 1637748869000,
            salePrice: "RM1.00",
            price: "",
            product_id: 18,
            place: "Negeri Sembilan",
            title:
              "香片 茉莉花茶 Jasmine Tea 10g Chinese Tea 中国茶叶(花茶)  (Scented tea) Teh CinaShopMalaysiaLocal Seller",
            url:
              "https://my.xiapibuy.com//香片-茉莉花茶-Jasmine-Tea-10g-Chinese-Tea-中国茶叶(花茶)-(Scented-tea)-Teh-Cina-i.544698837.12833891783?sp_atk=10d64e1f-b58e-403c-8c02-1d2a0d069431",
            labels: [],
            soldNum: 804,
            review: 42,
            star: 3,
          },
          {
            country: "马来西亚",
            tea: "大红袍",
            image:
              "https://cf.shopee.com.my/file/23e3de3453e478bb125a79485dbe397d_tn",
            sold: "2 sold",
            create_time: 1637748869000,
            salePrice: "RM74.00 - RM89.80",
            price: "",
            product_id: 117,
            place: "Mainland China",
            title:
              "绿茶雨前龙井 铁观音 金骏眉 大红袍 新茶叶礼盒装散装送礼高档佳品清香型 Green tea, Longjing Tieguanyin Jinjunmei Dahongpao, new tea gift boxes, bulk gifts, high-end products and delicate fragrance.RM5 offCOD",
            url:
              "https://my.xiapibuy.com//绿茶雨前龙井-铁观音-金骏眉-大红袍-新茶叶礼盒装散装送礼高档佳品清香型-Green-tea-Longjing-Tieguanyin-Jinjunmei-Dahongpao-new-tea-gift-boxes-bulk-gifts-high-end-products-and-delicate-fragrance.-i.513884826.11546337011?sp_atk=b3571530-4aaf-4fa5-a9b9-6b1c549754e8",
            labels: [],
            soldNum: 1218,
            review: 71,
            star: 4,
          },
        ],
        axiosParams: {
          country: "",
          tea: "",
          keyword: "Tea",
          limit: 9999,
        },
        pagiation: {
          current: 1,
          total: "",
          count: 10,
        },
      },
      sellers: {
        axiosParams: {
          country: "",
          tea: "",
          limit: 9999,
        },
        items: [{}],
        pagiation: {
          current: 1,
          total: "",
          count: 10,
        },
      },
    };
  },
  computed: {
    productItems: function() {
      return this.products.items.slice(
        (this.products.pagiation.current - 1) * this.products.pagiation.count,
        this.products.pagiation.current * this.products.pagiation.count
      );
    },
  },
  created() {
    this.$axios
      .post("/student/data/present/platform/seller", this.sellers.axiosParams)
      .then((res) => {
        if (res.succeed) {
          this.sellers.items = res.items;
        }
      });
  },
  methods: {
    overSelection(e) {
      e.target.classList.add("overing");
    },
    outSelection(e) {
      e.target.classList.remove("overing");
    },
    showMore() {
      this.hid = true;
      setTimeout(() => {
        if (this.DriverInstance?.currentStep === 5) {
          this.$emit("driverNext");
        }
      }, 100);
    },
    back() {
      this.hid = false;
      if (this.DriverInstance?.currentStep === 6) {
        this.$emit("driverNext");
      }
    },
    getProduct() {
      this.$axios
        .post(
          "/student/data/present/platform/product",
          this.products.axiosParams
        )
        .then((res) => {
          if (res.succeed) {
            this.products.items = res.items;
          }
        });
    },
    clickSearchInfo(label) {
      this.search = label;
    },
    handleSearch() {
      if (this.search === "") {
        this.products.axiosParams.keyword = this.search = "Tea";
      } else {
        this.products.axiosParams.keyword = this.search;
        this.products.pagiation.current = 1;
        this.getProduct();
      }
    },
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
* {
  font-family: Roboto, "Helvetica Neue", Helvetica, Arial, æ–‡æ³‰é©›æ­£é»‘,
    "WenQuanYi Zen Hei", "Hiragino Sans GB", "å„·é»‘ Pro", "LiHei Pro",
    "Heiti TC", å¾®è»Ÿæ­£é»‘é«”, "Microsoft JhengHei UI", "Microsoft JhengHei",
    sans-serif;
}

* {
  border: 1px solid transparent;
}

.product-content .error:not(.exclude),
.elscrollbar2 .seller-content .error:not(.exclude) {
  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #fe4a49;
    opacity: 0.9;
    z-index: 999;
  }
  &:after {
    content: "错误选择";
    font-family: "Microsoft YaHei", serif;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    color: #ffffff;
    z-index: 999;
  }
}

.shopee-container {
  width: 100%;
  background: #f5f5f5;
  position: relative;

  .header-container {
    padding: 0 20px;
    background: linear-gradient(-180deg, #f53d2d, #f63);

    .navbar {
      height: 34px;
      display: flex;
      align-items: center;
      color: white;

      svg {
        width: 16px;
        height: 16px;
        fill: white;
      }

      .navbar-left,
      .navbar-right {
        display: flex;
        align-items: center;

        div.split {
          height: 12px;
          width: 1px;
          margin: 0 12px;
          background: white;
        }

        div.no-split {
          display: flex;
          align-items: center;
          padding-left: 10px;
        }

        div.split-line {
          display: flex;
          align-items: center;

          svg {
            margin-right: 4px;
            fill: white;
          }

          border-right: 2px solid rgba(255, 255, 255, 0.22);
          padding: 0 8px;
        }

        .icon-wrap {
          display: flex;
          align-items: center;

          svg {
            margin-right: 4px;
          }
        }
      }

      .navbar-space {
        flex-shrink: 1;
        flex-grow: 1;
      }

      .navbar-right {
        display: flex;
        align-items: center;
      }
    }

    .container-wrapper {
      display: flex;
      align-items: center;
      height: 85px;

      .search-wrap {
        flex-shrink: 1;
        flex-grow: 1;
        padding: 8px;

        &.driver-highlighted-element {
          background: #fb5533;
        }

        .search-box {
          .input-view {
            position: relative;

            div.icon {
              cursor: pointer;
              position: absolute;
              top: 0;
              bottom: 0;
              right: 10px;
              margin: auto;
              width: 60px;
              height: 34px;
              border-radius: 2px;
              background: #fb5533;
              display: flex;
              align-items: center;
              justify-content: center;

              &:hover {
                background: red;
              }

              svg {
                fill: white;
              }
            }

            input {
              width: 100%;
              height: 40px;
              font-size: 16px;
              padding: 0 10px;
              border-radius: 2px;
            }
          }

          .search-info {
            margin-top: 5px;
            color: white;
            padding: 4px;

            &.driver-highlighted-element {
              background: #fb5533;
            }

            span {
              cursor: pointer;
              margin-right: 12px;
              text-transform: capitalize;
              border: 1px solid transparent;

              &:hover {
                border: 1px solid #ffffff;
              }
            }
          }
        }
      }

      .logo {
        padding-left: 20px;
        padding-right: 40px;

        svg {
          width: 162px;
          height: 50px;
          fill: white;
        }
      }

      .shopcar {
        padding-left: 40px;
        padding-right: 20px;

        svg {
          width: 26px;
          height: 26px;
          fill: white;
        }
      }
    }
  }

  .el-scrollbar {
    height: 560px;
    width: 100%;
    display: block;

    &.hid {
      display: none;
    }
  }

  .main-container {
    background: #f5f5f5;

    .main-container-view {
      width: 990px;
      margin: auto;
    }

    .product-content,
    .seller-content {
      .section-title {
        display: flex;
        align-items: center;
        height: 25px;
        margin: 25px 6px;
        font-size: 14px;

        .section-title-txt {
          display: flex;
          align-items: center;
          flex: 1;

          .keyword {
            padding: 0 6px;
            font-size: 16px;

            > span {
              font-size: 16px;
              font-weight: 600;
              color: #ee4d2d;
            }
          }
        }

        .more-link {
          cursor: pointer;
          color: #ee4d2d;
          position: relative;

          .more-link-view {
            &.mark {
              transition: all 0.5s linear;
              border-color: #42b983;
              background: #42b983;
              position: relative;

              &:before {
                content: "";
                position: absolute;
                left: -4px;
                top: -4px;
                width: 100%;
                height: 100%;
                border: 2px solid #42b983;
                padding: 2px;
              }
            }
          }
        }
      }

      .seller-item {
        margin: 7px 6px;
        height: 120px;
        background: white;
        border-radius: 4px;
        transition: transform 0.1s cubic-bezier(0.4, 0, 0.6, 1),
          box-shadow 0.1s cubic-bezier(0.4, 0, 0.6, 1),
          -webkit-transform 0.1s cubic-bezier(0.4, 0, 0.6, 1);
        /*box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.05);*/
        box-shadow: 0 0 2px #9e9e9e;
        padding: 0 20px;
        display: flex;
        align-items: center;

        &.mark {
          transition: all 0.5s linear;
          border-color: #42b983;
          background: #42b983;
          position: relative;

          &:before {
            content: "";
            position: absolute;
            left: -4px;
            top: -4px;
            width: 100%;
            height: 100%;
            border: 2px solid #42b983;
            padding: 2px;
          }
        }

        &.sellers {
          box-shadow: 0 0 10px #000000;
        }

        .shop-img {
          width: 70px;
          height: 70px;
          border: 1px solid #cacaca;
          border-radius: 50%;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }

        .shop-info {
          padding: 0 20px 0 10px;
          flex-basis: 300px;

          .info-item-nickname {
            font-size: 18px;
            color: rgba(0, 0, 0, 0.8);
            line-height: 1.5;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }

          .info-item-username {
            font-size: 14px;
            color: rgba(0, 0, 0, 0.8);
            line-height: 1.5;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }

          .info-item-follow {
            margin-top: 6px;
            color: #ee4d2d;
            font-size: 12px;
          }
        }

        .shop-statistics {
          display: flex;

          .shop-statistics-item {
            position: relative;

            &.mark {
              transition: all 0.5s linear;
              border-color: #42b983;
              background: #42b983;
              position: relative;

              &:before {
                content: "";
                position: absolute;
                left: -4px;
                top: -4px;
                width: 100%;
                height: 100%;
                border: 2px solid #42b983;
                padding: 2px;
              }
            }

            &.sales {
              box-shadow: 0 0 10px blue;
              border-radius: 10px;
              transition: all 0.5s linear;
            }

            &.sellers {
              box-shadow: 0 0 10px black;
              border-radius: 10px;
              transition: all 0.5s linear;
            }

            &.evaluate {
              box-shadow: 0 0 10px #00bcd4;
              border-radius: 10px;
              transition: all 0.5s linear;
            }

            .shop-statistics-item-wrapper.summary {
              box-shadow: 0 0 10px white;
              border-radius: 6px;
              padding: 10px;
              position: absolute;
              left: 0px;
              top: -10px;
              z-index: -10;
              color: white;
              opacity: 0;

              .item-header {
                svg {
                  fill: white;
                  color: white;
                }

                span {
                  color: white;
                }
              }

              &.active {
                transition: z-index 0s linear 0.6s, opacity 0.3s linear 0.6s;
                z-index: 10;
                opacity: 1;
              }
            }

            .shop-statistics-item-wrapper {
              border-left: 1px solid rgba(0, 0, 0, 0.09);
              padding: 0 10px;
              min-width: 90px;
              text-align: center;
              display: inline-block;

              .item-header {
                text-align: left;

                svg {
                  width: 14px;
                  height: 14px;
                  fill: currentColor;
                  color: #ee4d2d;
                  stroke: currentColor;
                  margin-right: 8px;
                }

                span {
                  font-size: 16px;
                  color: #ee4d2d;
                }
              }

              .item-text {
                text-align: left;
                margin-top: 8px;
              }
            }
          }
        }
      }
    }

    .product-content {
      &.hid {
        display: none;
      }

      div.product-wrapper {
        display: flex;
        flex-wrap: wrap;
        overflow: hidden;
        margin-bottom: 20px;

        .product-item {
          display: block;
          color: rgba(0, 0, 0, 0.87);
          width: 184px;
          height: 348px;
          background: white;
          margin: 6px;
          border-radius: 4px;
          overflow: hidden;
          box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);

          .product-img {
            width: 186px;
            height: 186px;

            > img {
              height: 100%;
              object-fit: contain;
            }
          }

          div.product-details {
            margin: 7px;

            .product-title {
              font-size: 10px;
              height: 28px;
              word-wrap: break-word;
              line-height: 14px;
              overflow: hidden;
              display: -webkit-box;
              text-overflow: ellipsis;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              margin-bottom: 6px;
            }

            .product-seller {
              height: 16px;
              margin-top: 4px;

              span {
                color: white;
                border: 1px solid rgb(238, 77, 45);
                margin-right: 4px;
                padding: 0 2px;
                background: rgb(246, 145, 19);
              }
            }

            .product-price {
              color: #ee4d2d;
              margin-top: 5px;
              position: relative;
              font-size: 14px;

              span.sign {
                font-size: 10px;
              }

              span.price {
                font-size: 14px;
              }

              &.mark {
                transition: all 0.5s linear;
                border-color: #42b983;
                background: #42b983;
                position: relative;

                &:before {
                  content: "";
                  position: absolute;
                  left: -4px;
                  top: -4px;
                  width: 100%;
                  height: 100%;
                  border: 2px solid #42b983;
                  padding: 2px;
                }
              }
            }

            .product-other {
              height: 16px;
              margin-top: 6px;
            }

            .product-shop {
              margin-top: 6px;
              text-align: right;
              font-size: 10px;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.65);
            }
          }
        }
      }

      div.filter-wrap {
        margin: 7px 6px;
        height: 60px;
        background: rgba(0, 0, 0, 0.03);
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        border-radius: 6px;

        .filter-condition {
          padding: 0 20px;
          display: flex;

          div.label {
            height: 34px;
            line-height: 34px;
            margin-right: 20px;
          }

          div.condition-items {
            display: flex;

            > div.item {
              cursor: pointer;
              margin-right: 10px;
              height: 34px;
              line-height: 34px;
              padding: 0 15px;
              background: white;
              color: #000000;

              &.active {
                color: white;
                background: #ee4d2d;
              }
            }
          }
        }

        .pagination-wrap {
          padding: 0 20px;
          display: flex;
          align-items: center;

          .num {
            margin-right: 20px;
          }

          .prev-next {
            display: flex;

            .btn {
              cursor: pointer;
              width: 34px;
              height: 34px;
              background: white;
              text-align: center;
              line-height: 34px;

              &:first-child {
                border-right: 1px solid rgba(0, 0, 0, 0.06);
              }

              &.disabled {
                cursor: inherit;
                background: #f9f9f9;
              }
            }
          }
        }
      }
    }

    .seller-content {
      min-width: 990px;

      &.hid {
        display: none;
      }

      &.active {
        position: absolute;
        z-index: 10;
      }
    }
  }
}

::v-deep .el-scrollbar__wrap {
  overflow-x: hidden;
}
</style>
